export default Object.freeze({
  PORTUGUESE: "Português",
  ENGLISH: "Inglês",
  SPANISH: "Espanhol",
  UPDATING_LANGUAGE_WAITING: "Alterando idioma, aguarde um instante",
  UNABLE_TO_ALTER_LANGUAGE: "Não foi possível alterar o idioma do programa.\n",
  MONITORING: "Protocolo",
  PHYS_MEDIUM: "Meio físico",
  GENERAL: "Gerais",
  TS_EXPERT_PROT: "TS Expert - Protocolo",
  TS_EXPERT_DP: "TS Expert - Meio Físico",
  LIVE_LIST: "Live List",
  LIVE_LIST_MATRIX: "Matriz",
  OSCILLOSCOPE: "Osciloscópio",
  BAR_GRAPH: "Gráfico de barras",
  REPORT: "Relatório",
  INFOS: "Agenda",
  RESUME: "Resumo",
  LOG: "Log",
  CONFIG: "Configurações",
  SAVE: "Salvar",
  REMOVE: "Remover",
  TIME_ON_ANALYZER_DN: "Tempo de análise: ",
  GOOD_STRING_ANALYZER_DN: "Bom",
  ATTENTION_STRING: "Atenção",
  BAD_STRING_ANALYZER_DN: "Ruim",
  MASTER_STRING: "Mestre",
  NO_SIGNAL_STRING: "Sem sinal",
  UNKNOWN_STRING: "Desconhecido",
  LIVE_LIST_INPUT_TEXT_PLACEHOLDER_ANALYZER_DN: "Filtrar por endereço ou sinal",
  ADDRESSES: "Endereços",
  ADDRESS: "Endereço",
  AMPLITUDE: "Amplitude",
  AMPLITUDE_PRE: "Amplitude preâmbulo",
  MEAN_AMPLITUDE: "Amplitude média",
  MEAN_AMPLITUDE_N: "Amplitude\nmédia",
  MIN_AMPLITUDE: "Amplitude mínima",
  MIN_AMPLITUDE_N: "Amplitude\nmínima",
  MAX_AMPLITUDE: "Sobressinal",
  NOISE: "Ruído",
  SIGNAL: "Sinal",
  STATUS: "Status",
  RATIO: "Razão",
  NETWORK_TAG: "Tag do segmento: ",
  IS_IN_SEGMENT: "Pertence ao\nSegmento?",
  IS_IN_SEGMENT_1: "Pertence ao",
  IS_IN_SEGMENT_2: "Segmento?",
  IS_IN_SEGMENT_DP: "Pertence ao Segmento: ",
  IS_IN_SEGMENT_QUESTION: "Pertence ao Segmento?",
  IS_IN_SEGMENT_LIVE_LIST_POPUP_1: "Indica se o dispositivo pertence ao mesmo segmento que este TS Monitor DN.",
  IS_IN_SEGMENT_LIVE_LIST_POPUP_2: "Esta opção deve ser ajustada manualmente para cada dispositivo na tela de configurações.",
  MIN_AMPLITUDE_1: "Amplitude",
  MIN_AMPLITUDE_2: "mínima",
  MEAN_AMPLITUDE_1: "Amplitude",
  MEAN_AMPLITUDE_2: "média",
  A: "A",
  B: "B",
  CHANNEL_A_PROBLEM: "Esta coluna é um indicador de problemas no canal A, fio verde, tais como:",
  CHANNEL_B_PROBLEM: "Esta coluna é um indicador de problemas no canal B, fio vermelho, tais como:",
  MASTERS: "Mestres",
  SLAVES: "Devices",
  AMPLITUDE_IDLE: "Tensão no idle ",
  BAUD_RATE_KBPS: "BAUD RATE (Kbps)",
  BAUD_RATE_MBPS: "BAUD RATE (Mbps)",
  NETWORK_DATA: "Dados da rede",
  MODAL_TITLE: "Formas de onda caracteristicas",
  TURNED_ON: "Ligada",
  TURNED_OFF: "Desligada",
  ANALYSIS_ERROR: "Ocorreu um erro ao alterar o estado da análise",
  ANALYSIS: "Análise",
  ANALYZER: "TS Monitor DN ",
  DETECTED_PROBLEMS: "Problemas detectados:",
  INIT_PICO_NOT_FOUND: "TS Monitor DN não encontrado, por favor conecte-o ao computador.",
  MONGO_OFF: "O TS Monitor DN detectou um erro em sua base de dados interna. Por favor, reinicie o TS Monitor DN. Caso o problema persista entre em contato com a Toledo & Souza para obter suporte.",
  PICO_NOT_FOUND: "O TS Monitor DN encontrou um erro interno que o impediu de funcionar corretamente. Por favor, reinicie o TS Monitor DN. Caso o problema persista entre em contato com a Toledo & Souza para obter suporte.",
  MONGO_REPAIR_SUCCESS: "Erro reparado com sucesso! Por favor feche o programa e abra novamento para que as alterações tenham efeito.",
  MONGO_REPAIR_ERROR: "Não foi possível solucionar o problema. Por favor entre em contato para receber suporte.",
  INIT_PICO_NOT_FOUND_PLAY: "Erro ao iniciar o TS Monitor DN. Por favor desconecte-o do seu computador, conecte novamente, e reinicie o programa. Caso o erro persista, reinicie o computador e tente novamente.",
  REPAIR: "Reparar",
  LOADING_ANALYZER: "Iniciando TS Monitor DN, por favor aguarde.",
  NO_DP_ACTIVE_NETWORK: "O TS Monitor DN não encontrou uma rede ativa, certifique-se de que está conectado corretamente a uma rede DeviceNet DP e tente novamente.",
  INVALID_SERIAL: "O número de série não corresponde a este TS Monitor DN. Por favor reinstale o programa com um número de série válido.",
  MONGO_OFF_POPUP: "Erro ao inicializar a base de dados, clique no botão abaixo para reparar o problema.",
  MEAN_AMPLITUDE_DESC: "Valor de amplitude medido entre a média dos pontos em nível lógico alto e a média dos pontos em nível lógico baixo, como ilustra a figura abaixo.",
  MEAN_AMPLITUDE_DESC_2: "A amplitude média alta é um indicativo de falta de terminadores. Já quando esta baixa indica: Resistência nas conexões; excesso de terminadores; cabos prensados; cabos amassados ou dobrados etc.",
  AMPLITUDE_MIN_DESC: "Valor de amplitude entre o menor ponto da forma de onda em nível lógico alto e o maior ponto em nível lógico baixo, como ilustra a figura abaixo.",
  AMPLITUDE_MIN_DESC_2: "Uma diferença grande entre a amplitude média e a mínima indica: Reflexão (terminadores); cabo longo; ruído; umidade no barramento etc.",
  OVERSHOOTING_DESC: "Valor de amplitude entre o valor médio da forma de onda em nível lógico alto e o maior ponto em nível lógico alto, como ilustra a figura abaixo.",
  OVERSHOOTING_DESC_2: "Indica: Falta de terminadores; conexões no meio do barramento; derivações etc.",
  RATIO_DESC_1: "Razão entre os valores de amplitude mínima e amplitude média, com o intuito de deixar evidente a degradação do sinal.",
  RATIO_DESC_2: "Quanto mais próximo de 1 melhor, e quanto mais próximo de 0 (zero) pior a qualidade do sinal.",
  RATIO_FOMULA: "Razão = Amp. mínima / Amp. média",
  IDLE_DESCRIPTION: " Período em que a rede está ociosa, ou seja, é o período entre uma pergunta do mestre e a resposta do device,  ou entre pacotes do mestre para ele mesmo. A tensão ideal do idle é de 1V, valores diferentes indicam problemas na rede.",
  MONITOR_IP_NOT_FOUND: "IP do monitor não encontrado",
  SCAN_FAIL_FOUND: "O TS Monitor DN perdeu a conexão com a rede DeviceNet, certifique-se de que ele está conectado corretamente à rede. Após realizar a conexão, por favor reinicie o TS Monitor DN.",
  GRAPH: "Gráfico",
  A_AND_B: "A e B",
  B_A: "B - A",
  WAVE_FORM: "Forma de onda",
  AMPLITUDE_A: "Amplitude A",
  AMPLITUDE_B: "Amplitude B",
  ADDRESS_DN: "Endereço: ",
  WAVE_A: "Sinal A",
  WAVE_B: "Sinal B",
  WAVE_DN: "Sinal DeviceNet",
  WAVE_PA: "Sinal PA",
  NANOSSECOND: "ns",
  MICROSSECOND: " µs",
  MILLISSECOND: " ms",
  SECOND: "s",
  TIME_NS: "Tempo (ns)",
  TIME_US: "Tempo (μs)",
  TIME_MS: "Tempo (ms)",
  TIME_S: "Tempo (s)",
  AMPLITUDE_PLACEHOLDER: "0.0 V",
  TIME_INTERVAL_PLACEHOLDER: "0.0",
  VOLTAGE: " V",
  VOLTAGE_PEAK_TO_PEAK: " V",
  CURSORS: "Cursores",
  CONTROLS: "Controles ",
  TIME_INTERVAL: " tempo",
  CONTROLS_POPUP_TEXT: "Após apertar PLAY, a forma de onda é atualizada aproximadamente a cada 200 milissegundos.",
  CONTROLS_POPUP_TEXT_2: "Para liberar os controles é preciso selecionar a visualização manual e escolher um dispositivo.",
  SIZE: "Tamanho ",
  VISUALIZATION: "Visualização",
  AUTOMATIC: "Automática",
  MANUAL: "Manual",
  STD_WAVE_FORM: "Forma de onda padrão",
  LONG_CABLE_WAVE_FORM: "Forma de onda típica de cabo longo",
  EXCESS_TERMINATIOR_WAVE_FORM: "Forma de onda típica de excesso de terminador",
  NO_SLAVE_WAVE_FORM: "Forma de onda típica de ausência de device (dispositivos desconectados)",
  REFLECTION_WAVE_FORM: "Forma de onda típica com reflexão",
  NO_TERMINATOR_WAVE_FORM: "Forma de onda típica de falta de terminador",
  FOR_MORE_INFO_DP: "Para informações adicionais, consulte a Toledo & Souza ou as diretrizes da DeviceNet International. Vale ressaltar que os eventos demonstrados podem acontecer em conjunto o que muda o padrões demonstrados.",
  FEW_TERMINATOR_WAVE_FORM: "Forma de onda típica de pouco terminador",
  WAVE_SIZE_DESC_1: "O TS Monitor DN já amostra o frame de dois modos com apenas 1 Byte ou com 3 Bytes, de tal modo que aqui conseguimos visualizar com um zoom maior em 1 Byte ou um zoom menor em 3 Bytes.",
  WAVE_SIZE_DESC_2: "Existe uma exceção: O frame “E5” – short acknowledgement – só tem 1 Byte, sempre.",
  WAVE_SIZE_DESC_3: "Abaixo um exemplo em um frame com mais de 1 e 3 Bytes.",
  TS_SCOPE_NOT_FINDING_ANSWER: "O TS Monitor DN não está encontrando resposta do device, portanto os dados estão desatualizados. A forma de onda abaixo é a última capturada pelo sistema.",
  ORDER_BY: "Classificar por",
  AMPLITUDE_ASC: "Amplitude crescente",
  AMPLITUDE_DESC: "Amplitude decrescente",
  ADDRESS_ASC: "Endereço crescente",
  VOLTAGE_V: "Tensão (V)",
  VOLTAGE_V_PEAK_TO_PEAK: "Tensão (V)",
  VOLTAGE_MV: "Tensão (mV)",
  VOLTAGE_MV_PEAK_TO_PEAK: "Tensão (mV)",
  ORDER: "Ordenação",
  REFRESH_DATA: "Atualizar dados",
  LOADING: "Carregando",
  INSERT_VALID_ADDRESS_OR_TYPE: "Favor digite um endereço ou tipo de evento válidos.",
  BEFORE_MONITOR_INIT_STR: "Anterior à última inicialização",
  LOG_INPUT_TEXT_PLACEHOLDER_ANALYZER_DN: "Filtrar por endereço ou tipo de evento",
  LOG_WAITING: "Carregando dados do log",
  TYPE: "Tipo",
  ATTENTION_SIGNAL_LOG_DESCRIPTION: "O TS Expert detectou um sinal com amplitude baixa (Sinal em estado de Atenção).",
  NO_TERMINATION_LOG_DESCRIPTION: "O TS Expert detectou uma possível ausência de terminador no segmento ao qual está conectado.",
  NO_POWER_SUPPLY_LOG_DESCRIPTION: "O TS Expert detectou possível falta de alimentação no terminador.",
  BAD_SIGNAL_LOG_DESCRIPTION: "O TS Expert detectou um sinal com amplitude baixa (Sinal Ruim).",
  A_NOT_OK_LOG_DESCRIPTION: "O TS Expert detectou possível curto-circuito entre o condutor A e a malha de blindagem, ou a massa aterrada de um painel ou device.",
  B_NOT_OK_LOG_DESCRIPTION: "O TS Expert detectou possível curto-circuito entre o condutor B e a malha de blindagem, ou a massa aterrada de um painel ou device.",
  LONG_CABLE_LOG_DESCRIPTION: "O TS Expert detectou uma possível condição de barramento com comprimento maior do que o permitido.",
  REFLECTION_LOG_DESCRIPTION: "O TS Expert detectou a presença de reflexão na forma de onda.",
  DEFORMED_WAVE_LOG_DESCRIPTION: "O TS Expert detectou a presença de sinal fora do padrão.",
  DUPLICATE_LOG_DESCRIPTION: "O TS Expert detectou possível presença de dois devices com o mesmo endereço na rede.",
  STATUS_CHANGE: "Mudança de estado: ",
  EVENT_CHECKED_SUCCESS_ANALYZER_DN: "O evento foi conferido com sucesso.",
  REPORT_EXPORT_NAME_ANALYZER_DN: "Relatório TS Monitor DeviceNet - Meio Físico",
  HEADER_TEXT_ANALYZER_DN: "Relatório de dados - TS Monitor DeviceNet - Meio Físico",
  GENERATE_REPORT: "Gerar relatório",
  ANALYZER_VERSION_STRING: "- Versão do monitor:",
  ANALYZER_VERSION: "1.2.0",
  PROTOCOL: "- Protocolo:",
  PROTOCOL_TYPE: "DeviceNet",
  ANALYSIS_INIT: "- Início do monitoramento:",
  REPORT_GENERATION: "- Geração do relatório:",
  ANALYSIS_DURATION: "- Duração do monitoramento até a geração do relatório: ",
  GENERAL_REPORT: "Relatório geral – TS Monitor DeviceNet",
  DATA_REPORT: "Relatório de dados – TS Monitor DeviceNet",
  CLIENT_INFO: "Informações do cliente",
  EXECUTING_COMPANY_INFO: "Informações da empresa executora",
  CONFORMITY: "Conformidade",
  REPORT_TYPE: "Tipo de Relatório",
  ANNOTATIONS: "Anotações",
  CONCLUSION: "Conclusão",
  DROPDOWN_PLACEHOLDER: "Escolha uma opção",
  CONFORM: "Conforme",
  CONFORM_W_RESTRICTION: "Conforme com restrições",
  NON_CONFORM: "Não conforme",
  PROJECT_NAME: "- Nome do projeto:",
  NETWORK_NAME: "- Nome da rede:",
  LOCATION: "- Localização:",
  COMPANY_NAME: "- Nome da empresa:",
  ACCOUNTABLE_NAME: "- Nome do responsável:",
  COMPANY_ADDRESS: "- Endereço:",
  COMPANY_CITY: "- Cidade:",
  COMPANY_TEL: "- Telefone:",
  EXECUTING_COMPANY_NAME: "- Nome da empresa:",
  EXECUTING_ACCOUNTABLE_NAME: "- Nome do responsável:",
  EXECUTING_TEL: "- Telefone:",
  EXECUTING_EMAIL: "- Email:",
  SUMMARY: "Sumário",
  A_LIVE_LIST_PAGE_TITLE: "1. - Live List",
  A_OSCILLOSCOPE_PAGE_TITLE: "2. - Osciloscópio",
  A_BAR_GRAPH_PAGE_TITLE: "3. - Gráfico de barras",
  A_LOG_PAGE_TITLE: "4. - Log de eventos",
  B_LIVE_LIST_PAGE_TITLE: "2.1. - Live List",
  B_OSCILLOSCOPE_PAGE_TITLE: "2.2. - Osciloscópio",
  B_BAR_GRAPH_PAGE_TITLE: "2.3. - Gráfico de barras",
  B_LOG_PAGE_TITLE: "2.4. - Log de eventos",
  ANALYSIS_INFO: "Informações do monitoramento",
  GENERATED_BY: "- Gerado por TS Monitor DN",
  HARDWARE_VERSION: "- Versão de hardware:",
  SOFTWARE_VERSION: "- Versão de software:",
  DATE_TIME: "- Data e hora:",
  BAUD_RATE_ANALYZER_DN: "- Baud rate:",
  CYCLE_TIME_ANALYZER_DN: "- Tempo de ciclo:",
  NUM_MASTERS: "- Mestres:",
  NUM_SLAVES: "- Devices:",
  AMPLITUDE_IDLE_1: "- Tensão no idle:",
  REDE_TAG: "- Tag da rede: ",
  ETHERNET_INFO: "Informações ETHERNET",
  IP_DN: "- IP: ",
  MASK_DN: "- Máscara: ",
  GATEWAY_DN: "- Gateway: ",
  NETWORK_NAME_DN: "- Nome da rede: ",
  LIVE_LIST_DOTS_ANALYZER_DN: "........................................................................................................................................",
  BAR_DOTS: ".........................................................................................................................",
  OSC_DOTS: "................................................................................................................................",
  LOG_DOTS: "................................................................................................................................................",
  DISCLAIMER_DOTS_ANALYZER_DN: "....................................................................................................................................",
  GENERATING_REPORT_WAITING: "Gerando relatório, por favor aguarde",
  GENERATING_REPORT_SUCCESS: "Relatório gerado com sucesso. Para salvá-lo, clique em salvar relatório abaixo.",
  SELECT_REPORT_TYPE: "Por favor selecione um tipo de relatório",
  MASTER_DN: "Mestre: ",
  SLAVE_DN: "Device: ",
  SIGNAL_DN: "Sinal: ",
  AMPLITUDE_DP: "Amplitude: ",
  AMPLITUDE_PRE_DP: "Amplitude preâmbulo: ",
  AMPLITUDE_MIN_DN: "Amplitude mínima: ",
  OVERSHOOTING_DP: "Sobressinal: ",
  AMPLITUDE_MAX_DP: "Amplitude máxima: ",
  MODEL: "Modelo",
  HORARY: "Horário",
  DESCRIPTION: "Descrição",
  GENERAL_INFORMATION: "Informações gerais",
  LAST_200_EVENTS: "200 últimos eventos",
  END_OF_REPORT: "Fim do relatório",
  DISCLAIMER: "Aviso legal",
  DISCLAIMER_TEXT: "Os dados e valores apresentados neste relatório são meramente auxiliares para o especialista em DeviceNet, de tal sorte que qualquer indicação de correção deve ser feita pelo usuário. Por esta razão, recomenda-se acompanhamento de engenheiro certificado DeviceNet ou técnico responsável pela análise para atestar as informações prestadas pelo produto. Portanto a Toledo & Souza se exime de quaisquer responsabilidades, perdas ou danos, diretos ou indiretos causados pelas interpretações do software, não oferecendo nenhuma garantia em relação à integridade, qualidade ou adequação das informações prestadas, pois dependem da análise técnica de um profissional capacitado, sendo que na falta deste, o usuário assumirá o risco de que o conteúdo possa ser impreciso, incompleto ou possa não atender às suas necessidades e requisitos.",
  CAPTURE_TIME: "Horário da captura",
  LOGIN: "LOGIN",
  ENTER: "Entrar",
  LOGOUT: "Logout",
  RESTART_SYSTEM_ANALYZER_DN: "Reiniciar Sistema",
  IP: "IP",
  MASK: "Máscara",
  GATEWAY: "Gateway",
  DNS: "DNS",
  TAG: "Tag",
  TAGS: "Tags",
  SETUP: "Configurar",
  EDIT: "Editar",
  SOFTWARE_UPDATE: "Atualização de Software",
  INTERFACE_CONFIG: "Configurações de Interface",
  CURRENT_VERSION: "Versão atual: ",
  UPDATE: "Atualizar",
  ALTER_LOGIN: "Alterar login",
  ARE_YOU_SURE_ALTER_CONFIG_ANALYZER_DN: "Tem certeza que deseja alterar as configurações Ethernet do TS Monitor DN?",
  INVALID_OR_CORRUPT_FILE: "O arquivo não é válido ou está corrompido.",
  IMPORT: "Importar",
  EXPORT: "Exportar",
  LOGIN_CREDENTIALS_FAILURE: "Ocorreu um erro ao realizar o login: Nome de usuário ou senha incorretos.",
  LOGIN_GENERAL_FALIURE: "Ocorreu um erro ao realizar o login:",
  GPG_ALERT_MESSAGE: "Só é possível enviar arquivos com extensão .gpg",
  GPG_FILE_EXTENSION: ".gpg",
  SEND_FILE_SUCCESS: "O arquivo foi enviado com sucesso.",
  SEND_FILE_SUCCESS_WARNING: "Não esqueça de verificar se a placa de rede do seu computador está na mesma subrede do IP: ",
  SEND_FILE_FAILURE: "Ocorreu um erro ao enviar o arquivo.",
  SEND_FILE_WAITING: "Enviando o arquivo.",
  SEND_FILE_WRONG_FILENAME_ANALYZER_DN: "Nome inválido. O arquivo de atualização deve chamar-se: updateRMDP.tar.gz.gpg",
  SEND_FILE_CORRUPTED_FILE: "O arquivo de atualização foi corrompido durante o envio.",
  SEND_CONFIG_SUCCESS: "As configurações foram enviadas com sucesso.",
  SEND_CONFIG_FAILURE: "Ocorreu um erro ao enviar as configurações.",
  SEND_CONFIG_WAITING: "Enviando as configurações.",
  SEND_CONFIG_WAITING_2: "Finalizando envio das configurações.",
  SEND_CONFIG_DONE: "Configurações enviadas.",
  START_MESSAGE_SUCCESS: "O monitor irá iniciar em 15 segundos.",
  START_MESSAGE_FAILURE: "Ocorreu um erro ao iniciar o monitor.",
  STOP_MESSAGE_SUCCESS: "O monitor irá parar em 15 segundos.",
  STOP_MESSAGE_FAILURE: "Ocorreu um erro ao parar o monitor.",
  CLEAN_STATISTICS_SUCCESS: "As estatísticas foram limpadas com sucesso.",
  CLEAN_STATISTICS_FAILURE: "Ocorreu um erro ao limpar as estatísticas.",
  RESET_TRAFFIC_SUCCESS: "Os valores serão zerados na próxima varredura.",
  RESET_TRAFFIC_FAILURE: "Ocorreu um erro ao zerar os incrementos de erro.",
  RESET_DEVICES_SUCCESS: "Os dados de devices foram limpados com sucesso.",
  RESET_DEVICES_FAILURE: "Ocorreu um erro ao limpar os dados de devices.",
  CHANGE_USERNAME_SUCCESS: "O Nome de usuário foi alterado com sucesso. Por favor realize o login novamente.",
  CHANGE_USERNAME_FAILURE: "Ocorreu um erro ao alterar o nome de usuário: ",
  USERNAME_TOO_SHORT: "O nome de usuário precisa conter pelo menos um caractere.",
  PASSWORD_MISSMATCH: "As senhas digitadas não coincidem",
  CHANGE_PASSWORD_SUCCESS: "A senha foi alterada com sucesso. Por favor realize o login novamente.",
  CHANGE_PASSWORD_FAILURE: "Ocorreu um erro ao alterar a senha: ",
  RESET_RETRIES_SUCCESS: "As retentativas foram limpadas com sucesso.",
  RESET_RETRIES_FAILURE: "Ocorreu um erro ao limpar as retentativas.",
  VERIFY_THE_FOLLOWING_INFO: "Por favor verifique as seguintes informações:",
  INVALID_IP: "\n- O IP inserido é inválido",
  INVALID_SUBMASK: "\n- A máscara inserida é inválida",
  INVALID_GATEWAY: "\n- O gateway inserido é inválido",
  INVALID_DNS: "\n- O DNS inserido é inválido",
  LOOPBACK_IP_ANALYZER_DN: "\n- O IP de loopback (127.0.0.1) não pode ser utilizado como IP do TS Monitor DN",
  LOOPBACK_IP_NTP: "\n- O IP de loopback (127.0.0.1) não pode ser utilizado como IP do servidor NTP",
  TAG_TOO_LONG_ANALYZER_DN: "\n- O tamanho da tag não pode ultrapassar 30 caracteres",
  EMPTY_WIFI_PWD: "\n- A senha da Wi-fi não pode ser vazia",
  SELECT_TIMEZONE: "\n- É necessário selecionar uma Timezone para configurar o servidor NTP",
  ALTER_USERNAME: "ALTERAR USUÁRIO",
  ALTER_PASSWORD: "ALTERAR SENHA",
  SYSTEM: "Sistema",
  RESTART: "Reiniciar",
  CONFIRM_RESTART_SYSTEM: "Tem certeza que deseja reiniciar o sistema?",
  RESTART_SYSTEM_FAILURE: "Ocorreu um erro ao tentar reiniciar o sistema.",
  RESTART_SYSTEM_SUCCESS: "Pedido de reinicialização enviado com sucesso. Aguarde cerca de 3 minutos para que o sistema seja reiniciado completamente.",
  SELECT_FILE: "Por favor selecione um arquivo para ser enviado",
  SELECT_GSD_FLIE: "Por favor selecione ao menos um arquivo GSD para ser enviado",
  SENDING_GSD_FILES: "Enviando arquivos GSD",
  DO_NOT_CLOSE_THIS_TAB: "Deixe esta aba aberta para acompanhar a atualização.",
  UPDATING_MONITOR_FILES_ANALYZER_DN: "Atualizando arquivos no TS Monitor DN. Por favor aguarde.",
  MONITOR_FILES_UPDATED_SUCCESSFULLY_ANALYZER_DN: "Arquivos atualizados, preparando para reiniciar o TS Monitor DN.",
  RESTARTING_MONITOR_WAIT_ANALYZER_DN: "Reiniciando o TS Monitor DN, aguarde alguns minutos.",
  UPDATE_SUCCESS: "A atualização foi realizada com sucesso!",
  UPDATE_ERROR_STRING_ANALYZER_DN: "Ocorreu o seguinte erro ao atualizar o TS Monitor DN: ",
  CHANGE_AT_LEAST_ONE_OF_THE_FIELDS: "Modifique pelo menos um dos campos para atualizar as configurações de interface.",
  SCOPE_DP_IP_WAS_CHANGED_SUCCESSFULLY: "• O IP do TS Monitor DN foi modificado com sucesso.",
  NOTE_WAS_CHANGED_SUCCESSFULLY: "• A observação foi modificada com sucesso.",
  REMEMBER_TO_UPDATE_BROWSER_ADDRESS_TO: "\nLembre-se de atualizar o endereço no navegador para: ",
  UPDATE_INTERFACE_CONFIG_SUCCESS: "As configurações de interface foram atualizadas com sucesso!",
  ALTER: "Alterar",
  NO: "Não",
  YES: "Sim",
  NOTE: "Observação",
  MONITOR_IP: "IP do Monitor",
  IN_SEGMENT_DEVICES: "Dispositivos do segmento",
  UPDATING_DATA: "Atualizando informações, aguarde",
  IN_SEGMENT_FORM_INPUT_PLACEHOLDER: "Filtrar dispositivos por endereço",
  IS_IN_SEGMENT_POPUP_DESCRIPTION_1: "Lista de dispositivos pertencentes ao mesmo segmento que o TS Monitor DN.",
  IS_IN_SEGMENT_POPUP_DESCRIPTION_2: "Se o dispositivo estiver desmarcado nesta lista, isto significa que ele não pertence ao mesmo segmento que o TS Monitor DN.",
  IS_IN_SEGMENT_POPUP_DESCRIPTION_3: "Se ele não pertencer ao mesmo segmento, a forma de onda vista no osciloscópio pode não corresponder à forma de onda real do dispositivo.",
  CONFIRM_ALTER_SEGMENT_DEVICES: "Tem certeza que deseja realizar as alterações à lista de dispositivos pertencentes ao segmento?",
  ALTER_IS_IN_SEGMENT_LIST_FAILURE: "Ocorreu um erro ao alterar a lista de dispositivos do segmento.",
  ALTER_IS_IN_SEGMENT_LIST_SUCCESS: "A lista de dispositivos do segmento foi alterada com sucesso!",
  TS_EXPERT_CONFIG_POPUP: "Permite habilitar / desabilitar as não conformidades a serem informadas pela ferramenta.",
  SEND_NTP_CONFIG_WAITING: "Enviando as configurações do servidor NTP.",
  SEND_NTP_CONFIG_DONE: "Configurações do servidor NTP enviadas.",
  NTP_SERVER: "Servidor NTP",
  TURN_NTP_SERVER_ON: "Ligar servidor NTP",
  TURN_NTP_SERVER_ON_QUESTION_ANALYZER_DN: "Tem certeza que deseja ligar o servidor NTP? Para isso o TS Monitor DN precisará ser reiniciado.",
  PROCESSING_NTP_INIT: "Iniciando processamento das informações do servidor NTP",
  PROCESSING_NTP_INFO: "Processando as informações do servidor NTP.",
  PROCESSED_NTP_INFO: "Informações do servidor NTP processadas.",
  PROCESSING_NTP_ERROR: "Ocorreu um erro ao enviar as informações para o servidor NTP. Verifique se o endereço IP do servidor está correto. Caso estiver, verifique também se o serviço de NTP está ligado e tente novamente.",
  NTP_INFO_TURNED_ON_SUCCESS: "O servidor NTP foi ligado com sucesso.",
  NTP_INFO_TURNED_ON_FAILURE: "Ocorreu um erro ao ligar o servidor NTP.",
  NTP_INFO_FAILURE: "Falha ao sincronizar com o servidor. Caso o erro persista entre em contato com o administrador do servidor NTP.",
  TURN_ON_DATE: "\nO horário do servidor foi atualizado para: ",
  MONITOR_WILL_BE_RESTARTED: "\nO TS Monitor DN será reiniciado agora,",
  MONITOR_RESTART_SUCCESS_ANALYZER_DN: "O TS Monitor DN foi reiniciado com sucesso.",
  MONITOR_RESTART_FAILURE_ANALYZER_DN: "Ocorreu um erro ao reiniciar o TS Monitor DN.",
  NTP_INFO_TURNED_OFF_SUCCESS: "O servidor NTP foi desligado com sucesso.",
  NTP_INFO_TURNED_OFF_FAILURE: "Ocorreu um erro ao desligar o servidor NTP.",
  TURN_OFF_DATE: "\nHorário de desligamento: ",
  ETHERNET: "Ethernet",
  ETHERNET_POPUP_1: "Campo de configuração da interface Ethernet.",
  ETHERNET_POPUP_2_ANALYZER_DN: "Utilizado para supervisão e acesso Web aos dados do TS Monitor DN.",
  WLAN: "WLAN",
  WLAN_POPUP_1: "Campo de configuração da interface sem fio, quando adaptador disponível.",
  WLAN_POPUP_2_ANALYZER_DN: "Utilizado para supervisão e acesso Web aos dados do TS Monitor DN.",
  TAG_CONFIG_ANALYZER_DN: "Tag do segmento:  ",
  TAG_WAS_CHANGED_SUCCESSFULLY_ANALYZER_DN: "A tag do TS Monitor DN foi modificada com sucesso.",
  TAG_CHANGE_FAILURE_ANALYZER_DN: "Ocorreu um erro ao modificar a tag do TS Monitor DN.",
  INVALID_MONITOR_IP: "O IP do monitor inserido é inválido.",
  MONITOR_IP_WAS_CHANGED_SUCCESSFULLY: "O IP do monitor foi modificado com sucesso.",
  MONITOR_IP_CHANGE_FAILURE: "Ocorreu um erro ao modificar o IP do monitor.",
  WAITING: "Aguarde um instante",
  CLEAN_LOG_SUCCESS: "O log foi limpado com sucesso.",
  CLEAN_LOG_FAILURE: "Ocorreu um erro ao limpar o log.",
  CLEAR: "Limpar",
  INVALID_HOSTNAME: "O hostname não estar em branco, nem conter espaços, ou caracteres especiais.",
  HOSTNAME_CONFIG_SUCCESS: "O hostname foi configurado com sucesso.",
  HOSTNAME_CONFIG_ERROR: "Ocorreu um erro ao configurar o hostname",
  MODE: "Modo",
  HIDDEN_SSID: "SSID Oculto",
  OPTIONAL: " (Opcional)",
  ALTER_MONITOR_WLAN_CONFIG_ANALYZER_DN: "Tem certeza que deseja alterar as configurações de WLAN do TS Monitor DN?",
  CHANGE_IDLE_SIZE: "Alterar tamanho do idle",
  CHANGE_IDLE_SIZE_QUESTION_1: "Alterar o tamanho do idle reiniciará os procedimentos internos do TS Monitor DeviceNet. Esse procedimento pode levar até 3 minutos.",
  CHANGE_IDLE_SIZE_QUESTION_2: "Ao clicar em sim, aguarde na tela até a finalização. Tem certeza que deseja prosseguir?",
  CHANGE_PACKET_SIZE: "Alterar tamanho de pacote",
  CHANGE_PACKET_SIZE_QUESTION_1: "Alterar o tamanho de pacote reiniciará os procedimentos internos do TS Monitor DeviceNet. Esse procedimento pode levar até 3 minutos.",
  CHANGE_PACKET_SIZE_QUESTION_2: "Ao clicar em sim, aguarde na tela até a finalização. Tem certeza que deseja prosseguir?",
  ADD_ALTER_TAGS: "Adicionar/Alterar Tags",
  CHOOSE_DEVICE: "Escolha um dispositivo",
  NEW_TAG: "Nova TAG",
  REMOVE_ALL_TAGS: "Remover todas as Tags",
  CONFIRM_REMOVE_ALL_TAGS: "Tem certeza que deseja remover as tags de todos os dispositivos?",
  CHANGE_TAG_SUCCESS: "A tag foi alterada com sucesso.",
  CHANGE_TAG_FAILURE: "Ocorreu um erro ao alterar a tag",
  REMOVE_TAG_SUCCESS: "As tags foram removidas com sucesso.",
  REMOVE_TAG_FAILURE: "Ocorreu um erro ao remover as tags",
  IMPORT_TAGS_SUCCESS: "As tags foram importadas com sucesso",
  IMPORT_TAGS_FAILURE: "Ocorreu um erro ao importar as tags: ",
  PLEASE_SELECT_TAG_FILE: "Por favor selecione um arquivo de tags.",
  IMPORT_TAGS: "Importar tags",
  EXPORT_TAGS: "Exportar tags",
  SENDING_TS_EXPERT_CONFIG_WAITING: "Atualizando as configurações do TS Expert, aguarde um instante.",
  TS_EXPERT_CONFIG_SAVED_SUCCESSFULLY: "As configurações do TS Expert foram salvas com sucesso.",
  TS_EXPERT_CONFIG_SAVE_ERROR: "Ocorreu um erro ao salvar as configurações do TS Expert.",
  TS_EXPERT_CONFIGURATION: "Configurações do TS Expert",
  BAD_SIGNAL_LIST_HEADER: "Existem dispositivos na rede com sinal ruim.",
  BAD_SIGNAL: "Existem dispositivos na rede com sinal ruim",
  DEVICE_BAD_SIGNAL: "Dispositivo com sinal ruim",
  BAD_SIGNAL_LIST_CONTENT: "Quando ativada esta opção, o TS Expert indicará ao usuário que a amplitude do sinal está muito menor que o padrão (Sinal Ruim).",
  DN_ATTENTION_SIGNAL_LOG_DESCRIPTION: "O TS Expert detectou um sinal com amplitude baixa (Sinal em estado de Atenção).",
  DN_BAD_SIGNAL_LOG_DESCRIPTION: "O TS Expert detectou um sinal com amplitude baixa (Sinal Ruim).",
  ATTENTION_SIGNAL_LIST_HEADER: "Existem dispositivos na rede com sinal em estado de atenção.",
  ATTENTION_SIGNAL: "Existem dispositivos na rede com sinal em estado de atenção",
  DEVICE_ATTENTION_SIGNAL: "Dispositivo com sinal em atenção",
  ATTENTION_SIGNAL_LIST_CONTENT: "Quando ativada esta opção, o TS Expert indicará ao usuário que a amplitude do sinal está menor que o padrão.",
  CAPACITIVE_EFFECT_LIST_HEADER: "Efeito Capacitivo.",
  NOISE_LIST_HEADER: "Ruído.",
  NOISE_LIST_CONTENT: "Quando ativada esta opção, o TS Expert indicará ao usuário possível condição de ruído na rede DeviceNet.",
  DEVICE_NOISE: "Dispositivo com ruído",
  NOISE_LOG_DESCRIPTION: "O TS Expert detectou uma possível condição de ruído na rede DeviceNet.",
  CAPACITIVE_EFFECT: "Efeito Capacitivo",
  DEVICE_CAPACITIVE_EFFECT: "Dispositivo com efeito capacitivo",
  CAPACITIVE_EFFECT_LIST_CONTENT: "Quando ativada esta opção, o TS Expert indicará ao usuário possível condição de barramento com comprimento maior do que o permitido ou alteração de impedância.",
  CAPACITIVE_EFFECT_LOG_DESCRIPTION: "O TS Expert detectou uma condição de efeito capacitivo.",
  TS_EXPERT_REPORT_EXPORT_NAME_ANALYZER_DN: "Lista de ações - TS Expert - TS Monitor DN",
  TS_EXPERT_POPUP_1: "Nesta aba são apresentadas as informações do TS Expert.",
  TS_EXPERT_POPUP_2_ANALYZER_DN: "Esta ferramenta é um sistema especialista desenvolvido para otimizar e acelerar a análise das principais divergências detectadas pelo TS Monitor DN em redes DeviceNet.",
  TS_EXPERT_POPUP_3: "De forma automatizada, a manutenção, engenharia e equipes relacionadas podem obter uma lista de ações com diferentes eventos, suas possíveis causas, sugestões de solução e os dispositivos nos quais foram detectados.",
  TS_EXPERT_POPUP_4: "O uso do TS Expert não exclui a necessidade da análise humana e tampouco substitui tais capacidades de criar correlações de dados e interpretação.",
  TS_EXPERT: "TS Expert",
  DETECTED_ON: "Detectado em: ",
  CHECK_YOUR_NETWORK: "Por favor verifique sua rede.",
  EXPORT_ACTIONS_LIST: "Exportar lista de ações",
  GENERATING_ACTIONS_LIST_WAITING: "Gerando PDF de lista de ações, por favor aguarde.",
  GENERATING_ACTIONS_LIST_SUCCESS: "PDF gerado com sucesso. Para salvá-lo, clique em salvar lista de ações.",
  EVENTS_LIST: "Lista de eventos",
  ACTIONS: "Ações",
  NO_PROBLEM_DETECTED: "O TS Expert não detectou nenhum evento na rede.",
  NO_EVENTS_TO_BE_ANALYZED: "Não existem eventos a serem analisados.",
  NO_EVENT_SELECTED: "Nenhum evento selecionado",
  CHOOSE_AN_EVENT: "Escolha um evento para visualizar as ações sugeridas.",
  DETAILING: "Detalhamento",
  CHECKED: "Conferido",
  BATCH_CHECK: "Conferir todos",
  PROBLEM_CHECKED: "O evento foi conferido com sucesso",
  PROBLEM_CHECK_ERROR: "Ocorreu um erro ao conferir o evento.",
  QUANTITY_DP: "Quantidade: ",
  INCREMENTS: "Incrementos",
  PORT_IS_STILL_INACTIVE: "A porta ainda está inativa",
  MARK_PROBLEM_AS_SOLVED: "Tem certeza que deseja marcar o evento como conferido?",
  LAST_UPDATED: "Atualizado pela última vez em: ",
  THIS_COMPUTER_TIME: " (Horário deste computador)",
  DEVICE: "Dispositivo",
  DEVICES: "Dispositivos",
  UNKNOWN: "Desconhecido",
  ATTENTION_SIGNAL_SUGGESTION_1: "Quando a amplitude do sinal estiver com status “atenção” sugere-se verificar:",
  ATTENTION_SIGNAL_SUGGESTION_2: "Se a rede tem mais do que dois terminadores conectados;",
  ATTENTION_SIGNAL_SUGGESTION_3: "Verificar a eletrônica dos devices, isolando individualmente do barramento;",
  ATTENTION_SIGNAL_SUGGESTION_4: "Verificar se existem bornes frouxos nas conexões por borne ou conectores a borne;",
  ATTENTION_SIGNAL_SUGGESTION_5: "Verificar se existem cabos amassados ou danificados.",
  ATTENTION_SIGNAL_SUGGESTION_6: "Esta verificação pode ser feita com a rede trabalhando, porém para qualquer intervenção indica-se esperar uma parada, pois estas alterações podem derrubar a rede.",
  BAD_SIGNAL_SUGGESTION_1: "Quando a amplitude do sinal estiver com status “ruim” sugere-se verificar preventivamente:",
  BAD_SIGNAL_SUGGESTION_2: "Verificar:",
  BAD_SIGNAL_SUGGESTION_3: "Se a rede tem mais do que dois terminadores conectados;",
  BAD_SIGNAL_SUGGESTION_4: "Verificar a eletrônica dos devices, isolando individualmente do barramento;",
  BAD_SIGNAL_SUGGESTION_5: "Verificar se existem bornes frouxos nas conexões por borne ou conectores a borne;",
  BAD_SIGNAL_SUGGESTION_6: "Verificar se existem cabos amassados ou danificados.",
  BAD_SIGNAL_SUGGESTION_7: "Verificar se existem cabos amassados, o que aumentaria a resistência do cabo.",
  BAD_SIGNAL_SUGGESTION_8: "Esta verificação pode ser feita com a rede trabalhando, porém para qualquer intervenção indica-se esperar uma parada, pois estas alterações podem derrubar a rede.",
  CAPACITIVE_EFFECT_SUGGESTION_1: "Quando for detectado efeito capacitivo sugere-se:",
  CAPACITIVE_EFFECT_SUGGESTION_1_REPORT: "Quando for detectado efeito capacitivo:",
  CAPACITIVE_EFFECT_SUGGESTION_2: "Fazer uma inspeção visual do segmento e verificar se o barramento está longo demais para o baud rate atual (taxa de comunicação).",
  CAPACITIVE_EFFECT_SUGGESTION_3: "Verificar as condições do cabeamento e substituir o que não estiver em boas condições.",
  NOISE_SUGGESTION_1: "Quando houver ruído ou baixa isolação (fuga para terra) sugere-se:",
  NOISE_SUGGESTION_2: "Este é um dos problemas mais complexos das redes industriais. Abaixo temos 4 dicas básicas que devem ajudar a solucionar este problema:",
  NOISE_SUGGESTION_3: "Verificar o isolamento das interfaces dos devices, um modo simples é desconectando um a um da rede e verificando se o problema persiste;",
  NOISE_SUGGESTION_4: "Para atenuar o ruído é necessário verificar se todos os devices da rede estão devidamente aterrados;",
  NOISE_SUGGESTION_5: "É necessário verificar a equipotencialização do sistema de terra, um modo simples é verificar se há corrente de fuga nos cabos DeviceNet. Espera-se um valor abaixo de 100mA;",
  NOISE_SUGGESTION_6: "Caso tenha uma corrente maior que 100mA uma dica é isolar a malha no device, sempre mantendo o device aterrado.",
  NOISE_SUGGESTION_7: "Se o problema persistir após estas dicas básicas, indicamos procurar um especialista em redes DeviceNet.",
  ATTENTION_SIGNAL_PAGE_TITLE: ". - Sinal em estado de atenção",
  NO_TERMINATION_PAGE_TITLE: ". - Segmento sem terminação",
  NO_POWER_SUPPLY_TERMINATION_PAGE_TITLE: ". - Terminador sem alimentação",
  BAD_SIGNAL_PAGE_TITLE: ". - Sinal ruim",
  A_NOT_OK_PAGE_TITLE: ". - Curto entra o condutor A e a malha",
  B_NOT_OK_PAGE_TITLE: ". - Curto entre o condutor B e a malha",
  CAPACITIVE_EFFECT_PAGE_TITLE: ". - Efeito Capacitivo",
  NOISE_PAGE_TITLE: ". - Ruído ou baixa isolação (fuga para terra)",
  REFLECTION_PAGE_TITLE: ". - Reflexão na forma de onda",
  DEFORMED_WAVE_PAGE_TITLE: ". - Sinal deformado",
  DUPLICATE_PAGE_TITLE: ". - Endereço duplicado",
  ATTENTION_SIGNAL_DOTS: "................................................",
  CAPACITIVE_EFFECT_DOTS: "............................................................................................................................",
  NO_TERMINATION_DOTS: "........................................................................................................",
  NO_POWER_SUPPLY_DOTS: "....................................................................................................",
  BAD_SIGNAL_DOTS: ".............................................................................",
  A_NOT_OK_DOTS: "...........................................................................................",
  B_NOT_OK_DOTS: "...........................................................................................",
  LONG_CABLE_DOTS: "..................................................................................................................................",
  NOISE_DOTS: "..............................................................................................................................................",
  REFLECTION_DOTS: "........................................................................................................",
  DEFORMED_WAVE_DOTS: ".......................................................................................................................",
  DEFORMED_WAVE_DOTS_2: ".........................................................................................................................",
  DUPLICATE_ADDRESS_DOTS: "..................................................................................................................",
  DUPLICATE_ADDRESS_DOTS_2: "....................................................................................................................",
  DISCLAIMER_EXPERT_DOTS: ".................................................................................................................................",
  DISCLAIMER_EXPERT_DOTS_2_ANALYZER_DN: "...................................................................................................................................",
  SUGGESTION: "Sugere-se",
  EVIDENCE: "Evidências",
  EVIDENCE_DESCRIPTION: "Captura de evidência da não conformidade informada pelo TS Expert:",
  ATTENTION_SIGNAL_PAGE_DESCRIPTION: "O TS Expert está indicando que a amplitude do sinal está menor que o padrão (Sinal em estado de Atenção).",
  NO_TERMINATION_PAGE_DESCRIPTION: "O TS Expert está indicando uma possível ausência de terminador no segmento ao qual está conectado.",
  NO_POWER_SUPPLY_PAGE_DESCRIPTION: "O TS Expert está indiciando uma possível falta de alimentação no terminador.",
  BAD_SIGNAL_PAGE_DESCRIPTION: "O TS Expert está indicando que a amplitude do sinal está muito menor que o padrão (Sinal Ruim).",
  A_NOT_OK_PAGE_DESCRIPTION: "O TS Expert está indicando possível curto-circuito entre o condutor A e a malha de blindagem ou a massa aterrada de um painel ou device.",
  B_NOT_OK_PAGE_DESCRIPTION: "O TS Expert está indicando possível curto-circuito entre o condutor B e a malha de blindagem ou a massa aterrada de um painel ou device.",
  CAPACITIVE_EFFECT_PAGE_DESCRIPTION: "O TS Expert está indicando possível condição de barramento com comprimento maior do que o permitido ou alteração de impedância, cujas causas típicas são excesso de dobras, cabos danificados, cabos úmidos e devices com problemas na eletrônica.",
  NOISE_PAGE_DESCRIPTION: "O TS Expert está indicando possível condição de ruído na rede DeviceNet.",
  REFLECTION_PAGE_DESCRIPTION: "O TS Expert está indicando a presença de reflexão na forma de onda.",
  DEFORMED_WAVE_PAGE_DESCRIPTION: "O TS Expert está indicando a presença de sinal fora do padrão",
  DUPLICATE_PAGE_DESCRIPTION: "O TS Expert está indicando a possível presença de endereço duplicado.",
  WLAN_STATUS: "Adaptador WLAN",
  WLAN_CONFIG: "Configurações WLAN",
  CONNECTION_STATUS: "Estado da conexão",
  WLAN_ADAPTER_ON: "Ligado",
  WLAN_ADAPTER_OFF: "Desligado",
  IP_PLACEHODLER_ANALYZER_DN: "192.168.2.210",
  SSID: "SSID",
  SIGNAL_STRENGTH: "Força do sinal",
  FREQUENCY: "Frequência",
  CHANNEL: "Canal",
  QUALITY: "Qualidade",
  SSID_PLACEHOLDER: "SSID",
  MAC_PLACEHOLDER: "A0:8C:FD:19:DB:02",
  SIGNAL_STRENGTH_PLACEHOLDER: "90 dBm",
  FREQUENCY_PLACEHOLDER: "2.4GHz",
  CHANNEL_PLACEHOLDER: "1",
  QUALITY_PLACEHOLDER: "Qualidade",
  TURNING_WLAN_OFF_WAITING: "Desligando o adaptador WLAN, por favor aguarde.",
  TURNING_WLAN_ON_WAITING: "Ligando o adaptador WLAN, por favor aguarde.",
  NETWORK: "Rede",
  NETWORK_NAME_1: "Nome da rede",
  SUBMASK: "Máscara",
  PASSWORD: "Senha",
  ALTER_SCOPE_WLAN_CONFIG: "Tem certeza que deseja alterar as configurações de WLAN do TS Monitor DN?",
  CONNECTED: "Conectada",
  DISCONNECTED: "Desconectada",
  WLAN_STATUS_POPUP_1_ANALYZER_DN: "Indica o estado do adaptador WLAN do TS Monitor DN.",
  WLAN_STATUS_POPUP_2: "Caso ele esteja desligado não é possível alterar as configurações WLAN.",
  CONNECTION_STATUS_POPUP_1_ANALYZER_DN: "Indica se o TS Monitor DN está conectado ou não à rede WLAN configurada.",
  WLAN_CONFIG_POPUP_1: "Não é possível alterar as configurações enquanto o adaptador WLAN estiver desligado.",
  WLAN_CONFIG_POPUP_2_ANALYZER_DN: "É altamente recomendado que as configurações de WLAN sejam alteradas apenas ao acessar o TS Monitor DN por meio da rede cabeada.",
  WLAN_CONFIG_POPUP_3: "Ao alterar o IP / máscara, caso os campos apareçam em branco após a atualização isso é um forte indicativo de que:",
  WLAN_CONFIG_POPUP_4: "Já existe um outro dispositivo na rede com o mesmo IP;",
  WLAN_CONFIG_POPUP_5: "A máscara de rede é muito restrita e não comporta o IP que foi passado.",
  WLAN_ADAPTER_NOT_FOUND_1_ANALYZER_DN: "O TS Monitor DN não conseguiu encontrar o adaptador WLAN:\n",
  WLAN_ADAPTER_NOT_FOUND_2_ANALYZER_DN: "  • Verifique se o adaptador está desconectado, ou com mau contato;\n",
  WLAN_ADAPTER_NOT_FOUND_3_ANALYZER_DN: "  • Caso o adaptador não esteja desconectado nem com mau contato, tente substituí-lo;\n",
  WLAN_ADAPTER_NOT_FOUND_4: "  • Se nenhuma das opções anteriores solucionar o problema entre em contato com a Toledo e Souza.",
  CHANGE_AT_LEAST_ONE_OF_THE_FIELDS_WLAN: "Modifique pelo menos um dos campos para atualizar as configurações WLAN.",
  UPDATE_WLAN_CONFIG_SUCCESS: "As configurações de WLAN foram atualizadas com sucesso!",
  SEND_WLAN_CONFIG_WAITING: "Enviando as configurações, por favor aguarde. Isso pode levar cerca de um minuto.",
  LOADING_WAITING: "Carregando informações, por favor aguarde.",
  WLAN_INFO: "Informações WLAN",
  MAC: "MAC",
  UPDATE_WLAN_CONFIG_ERROR_ANALYZER_DN: "Não foi possível conectar à rede WLAN. Caso o problema persista tente reiniciar o TS Monitor DN ou o roteador WLAN.",
  OK_STRING: "OK",
  IDLE_SIZE: "Tamanho do idle",
  PACKET_SIZE: "Tamanho de pacote",
  SMALL: "Pequeno",
  MEDIUM: "Médio",
  BIG: "Grande",
  IDLE_SIZE_QUESTION_ICON_INFO: "O tamanho do idle diz respeito à quantidade de pontos considerados no começo da forma de onda da resposta do device. É possível configurar três tamanhos distintos:",
  IDLE_SIZE_QUESTION_ICON_INFO_1: "Tamanho do idle padrão (Varia de acordo com o baud rate);",
  IDLE_SIZE_QUESTION_ICON_INFO_2: "Aumenta o tamanho em 1 tempo de um bit;",
  IDLE_SIZE_QUESTION_ICON_INFO_3: "Aumenta o tamanho em 2 tempos de um bit.",
  PACKET_SIZE_QUESTION_ICON_INFO: "O tamanho de pacote é a quantidade total de pontos que são capturados pelo TS Monitor DN em um único pacote de dados. É possível configurar três tamanhos distintos:",
  PACKET_SIZE_QUESTION_ICON_INFO_1: "Tamanho de pacote padrão (Varia de acordo com o baud rate);",
  PACKET_SIZE_QUESTION_ICON_INFO_2: "Aumenta o tamanho de pacote em 100 pontos;",
  PACKET_SIZE_QUESTION_ICON_INFO_3: "Aumenta o tamanho de pacote em 200 pontos.",
  IDLE_SIZE_WAITING: "Realizando procedimentos para alterar o tamanho do idle, por favor aguarde nesta tela até que eles terminem.",
  IDLE_SIZE_WAS_CHANGED_SUCCESSFULLY: "O tamanho do idle foi alterado com sucesso",
  IDLE_SIZE_CHANGE_FAILURE: "Ocorreu um erro ao alterar o tamanho do idle.",
  PACKET_SIZE_WAITING: "Realizando procedimentos para alterar o tamanho do pacote, por favor aguarde nesta tela até que eles terminem.",
  PACKET_SIZE_WAS_CHANGED_SUCCESSFULLY: "O tamanho de pacote foi alterado com sucesso",
  PACKET_SIZE_CHANGE_FAILURE: "Ocorreu um erro ao alterar o tamanho do pacote.",
  REASON_DP: "Motivo: ",
  CHECK_MASTER: "Verificar mestre",
  START_SEARCH_ERROR_MESSAGE: "Ocorreu um erro ao iniciar a busca de dispositivos. Por favor tente novamente.",
  SEARCH_FINISH_SUCCESS: "Busca por dispositivos finalizada com sucesso!",
  GET_DEVICES_LIST_ERROR: "Ocorreu um erro ao carregar a lista de dispositivos.",
  IN_SEGMENT: "Atualmente no segmento",
  POSSIBLY_IN_SEGMENT: "Identificado como pertencente",
  POSSIBLY_OUT_OF_SEGMENT: "Foi detectado que este dispositivo pode estar em outro segmento",
  SEND_SEGMENT_DEVICES_INFO_SUCCESS: "As informações sobre os dispositivos do segmento foram enviadas com sucesso!",
  SEND_SEGMENT_DEVICES_INFO_ERROR: "Ocorreu um erro ao enviar as informações sobre os dispositivos do segmento.",
  SEARCH: "Buscar",
  SEARCH_POPUP_1: "Para utilizar a parte de Meio Físico DN pela primeira vez é recomendado selecionar quais dispositivos pertencem ao segmento.",
  SEARCH_POPUP_2: "Aperte o botão abaixo para fazer uma busca e encontrar todos dispositivos alcançaveis na rede.",
  SEARCH_POPUP_3_1: "Após a busca, os dispositivos encontrados serão adicionados à lista de ",
  SEARCH_POPUP_3_2: "dispositivos disponíveis",
  SEARCH_POPUP_3_3: " ao lado. Os dispositivos disponíveis ",
  SEARCH_POPUP_3_4: "são todos aqueles encontrados, que pertencem ao segmento de rede atual, ou não.",
  SEARCH_POPUP_4_1: "A outra lista, de ",
  SEARCH_POPUP_4_2: "dispositivos selecionados",
  SEARCH_POPUP_4_3: ", é a lista que ",
  SEARCH_POPUP_4_4: "contém os dispositivos selecionados pelo usuário que ele tem certeza que estão no segmento de rede atual.",
  SEARCH_POPUP_4_5: " Inicialmente esta lista estará vazia.",
  SEARCH_POPUP_5: "Feito a busca, caberá ao usuário selecionar quais destes dispositivos realmente percentem ao segmento de rede, movendo eles da lista de dispositivos disponíveis para a lista de dispositivos selecionados.",
  SEARCH_POPUP_6_1: "OBS: ",
  SEARCH_POPUP_6_2: "Os mestres da rede são sempre monitorados pelo TS Monitor DeviceNet, portanto não aparecem nesta página.",
  SAVE_POPUP_1_1: "Ao clicar no botão abaixo, os dispositivos que estiverem na lista ",
  SAVE_POPUP_1_2: "Dispositivos selecionados",
  SAVE_POPUP_1_3: " serão salvos.",
  SAVE_POPUP_2_1: "Ao realizar este procedimento, apenas os dispositivos da lista ",
  SAVE_POPUP_2_2: "Dispositivos selecionados",
  SAVE_POPUP_2_3: " serão monitorados pelo Meio Físico DN, e ",
  SAVE_POPUP_2_4: "somente eles serão mostrados nas telas de Meio Físico DN, como: Live List, Matriz, Osciloscópio, etc.",
  EXPLANATION: "Explicação",
  SAVE_POPUP_3: "Esta funcionalidade é importante para identificar os devices pertencentes ao segmento de rede DeviceNet. O que diminui o tempo de reposta uma vez que o sistema estará verificando os devices pertinentes.",
  SAVE_POPUP_4: "Também é de grande valia para que aqueles que tenham menor conhecimento da rede não procurem o problema em um segmento errado.",
  AVAILABLE_DEVICES: "Dispositivos disponíveis",
  AVAILABLE_DEVICES_POPUP_1_1: "Esta lista contém todos os dispositivos ",
  AVAILABLE_DEVICES_POPUP_1_2: "encontrados na rede.",
  AVAILABLE_DEVICES_POPUP_2: "O TS Monitor DeviceNet sugere os dispositivos que ele acredita pertencerem ao segmento de rede atual, indicando eles como: ",
  AVAILABLE_DEVICES_POPUP_2_1: " Identificado como pertencente.",
  AVAILABLE_DEVICES_POPUP_3_1: "Clicar no botão ",
  AVAILABLE_DEVICES_POPUP_3_2: " move um dispositivo da lista de ",
  AVAILABLE_DEVICES_POPUP_3_3: "dispositivos disponíveis",
  AVAILABLE_DEVICES_POPUP_3_4: " para a lista de ",
  AVAILABLE_DEVICES_POPUP_3_5: "dispositivos selecionados",
  AVAILABLE_DEVICES_POPUP_3_6: ", indicando que ele pertence ao segmento atual da rede. Após mover os dispositivos é necessário clicar no botão ",
  AVAILABLE_DEVICES_POPUP_3_7: "Salvar",
  AVAILABLE_DEVICES_POPUP_3_8: " para gravar essas alterações.",
  AVAILABLE_DEVICES_POPUP_4_1: "OBS: ",
  AVAILABLE_DEVICES_POPUP_4_2: "Fica a cargo do usuário tomar a decisão final e decidir quais dispositivos realmente pertencem ao segmento.",
  LOADING_DEVICES: "Carregando dispositivos",
  MOVE_ALL: "Mover todos",
  SELECTED_DEVICES: "Dispositivos selecionados",
  SELECTED_DEVICES_POPUP_1_1: "Esta lista contém todos os dispositivos que o usuário marcou como ",
  SELECTED_DEVICES_POPUP_1_2: "pertencentes ao segmento de rede atual.",
  SELECTED_DEVICES_POPUP_2_1: "É importante ressaltar que após clicar no botão ",
  SELECTED_DEVICES_POPUP_2_2: "Salvar",
  SELECTED_DEVICES_POPUP_2_3: ", a parte de Meio Físico DN ",
  SELECTED_DEVICES_POPUP_2_4: "somente irá monitorar os dispositivos que estiverem na lista de dispositivos selecionados.",
  SELECTED_DEVICES_POPUP_3_1: "Isto significa que:",
  SELECTED_DEVICES_POPUP_3_2: " Os dispositivos que não estiverem nesta lista não serão mostrados nas telas de Meio Físico DN, tais como: Live list, Matriz, Osciloscópio, Gráfico de barras, etc.",
  CONFIRM_SEARCH_START: "Tem certeza que deseja iniciar a busca?",
  CONFIRM_SEARCH_START_POPUP_1_1: "O procedimento de busca de dispositivos levará ",
  CONFIRM_SEARCH_START_POPUP_1_2: "5 (cinco) minutos",
  CONFIRM_SEARCH_START_POPUP_1_3: " para ser completado.",
  CONFIRM_SEARCH_START_POPUP_2_1: " Durante a busca ",
  CONFIRM_SEARCH_START_POPUP_2_2: "diversos procedimentos internos do TS Monitor DeviceNet serão reiniciados",
  CONFIRM_SEARCH_START_POPUP_2_3: ", e por esta razão, ele somente voltará a funcionar normalmente após a busca ser finalizada.",
  SEARCHING_DEVICES: "Buscando dispositivos.",
  PLEASE_STAY_IN_PAGE: "Por favor permaneça na página para acompanhar o progresso da busca.",
  SENDING_DEVICES_INFO: "Enviando informações sobre os dispositivos, aguarde.",
  TIME_ON_PROTOCOL: "Tempo ligado: ",
  NUM_OF_DEVICES: "Número de dispositivos",
  MISSING: "Ausentes",
  STATISTICS: "Estatísticas",
  NO_RETRIES: "Sem retentativas",
  OCUP_BANDA: "OCUPAÇÃO DE BANDA (%)",
  CYCLE_TIME_S: "TEMPO DE CICLO (s)",
  CYCLE_TIME_MS: "TEMPO DE CICLO (ms)",
  MONITOR_TAG_STRONG: "TAG DO MONITOR",
  WATCHDOG_MS: "WATCHDOG (ms)",
  RETRIES_LIMIT: "LIMITE DE RETENTATIVA",
  DEVICENET_NETWORK_INFO: "Informações da rede DeviceNet",
  HSA_POPUP_1: "HSA (Highest DeviceNet Address) é o parâmetro que indica o maior endereço que o mestre realiza a busca por novos equipamentos na rede, utilizando o protocolo FDL_Status.",
  HSA_POPUP_2: "Utilizado também para detecção de mestres classe 2 ou redes com mais de um mestre.",
  AVAILABILITY: "Disponibilidade",
  LOST: "Lost",
  FALHA: "Falhas",
  RETRIE: "Retentativas",
  DIAGNOSTICS: "Diagnósticos",
  STATUS_DEVICE: "Status",
  ACTIVE: "Ativo",
  INACTIVE: "Inativo",
  REASON: "\nMotivo: ",
  MANUFACTURER_MODEL: "Fabricante / Modelo",
  ALTER_TAG_ERROR_REASON: ".\nMotivo: ",
  ERROR_REASON: ".\nMotivo: ",
  DN_CAPACITIVE_EFFECT_LOG_DESCRIPTION: "O TS Expert detectou uma condição de efeito capacitivo.",
  DN_NOISE_LOG_DESCRIPTION: "O TS Expert detectou uma possível condição de ruído na rede DeviceNet.",
  DN_DIAGNOSTIC_LOG_DESCRIPTION: "O TS Expert detectou diagnósticos.",
  DN_FAULT_LOG_DESCRIPTION: "O TS Expert detectou uma falha.",
  DN_RETRIES_LOG_DESCRIPTION: "O TS Expert detectou retentativas.",
  DN_ERROR_FRAME_LOG_DESCRIPTION: "O TS Expert detectou um error frame.",
  PROTOCOL_RETRIES_LOG_DESCRIPTION: "O TS Expert detectou retentativas no dispositivo.",
  PROTOCOL_ERROR_FRAME_LOG_DESCRIPTION: "O TS Expert detectou um error frame na rede.",
  EVENT_CHECKED_SUCCESS_PROTOCOL: "O evento foi limpo com sucesso.",
  SEND_FILES_SUCCESS: "Os arquivos foram enviados com sucesso.",
  SEND_FILE_WRONG_FILENAME_PROTOCOL: "Nome inválido. O arquivo de atualização deve chamar-se: updateDN.tar.gz.gpg",
  LOOPBACK_IP_PROTOCOL: "\n- O IP de loopback (127.0.0.1) não pode ser utilizado como IP do monitor",
  TAG_TOO_LONG_PROTOCOL: "O tamanho da tag não pode ultrapassar 30 caracteres",
  SAME_SUBNET_IP_1: "\n- O endereço IP da interface office não pode estar na mesma subrede da interface ETHERNET.",
  SAME_SUBNET_IP_2: "\n- O endereço IP da interface ETHERNET não pode estar na mesma subrede da interface office.",
  SUBNET_OVERLAP_WLAN: "\n- O TS Monitor DN detectou que existe sobreposição de endereços entre a subrede da interface ETHERNET e a subrede da WLAN. Por esse motivo não é possível configurar a WLAN com o endereço IP e máscara escolhidos.",
  SUBNET_OVERLAP_ETHERNET_WLAN: "\n- O TS Monitor DN detectou que existe sobreposição de endereços entre a subrede da interface ETHERNET e a subrede da WLAN. Por esse motivo não é possível configurar a interface ETHERNET com o endereço IP e máscara escolhidos.",
  ZERO_IP_MSG: "\n- O IP 0.0.0.0 não pode ser utilizado como IP do TS Monitor DN",
  ZERO_IP_MASK_MSG: "\n- O IP 0.0.0.0 não pode ser utilizado como máscara da rede",
  BROADCAST_IP_MSG: "\n- O IP de broadcast da rede não pode ser utilizado como IP do TS Monitor DN",
  NETWORK_IP_MSG: "\n- O IP da rede não pode ser utilizado como IP do TS Monitor DN",
  BROADCAST_GATEWAY_MSG: "\n- O IP de broadcast da rede não pode ser utilizado como IP do gateway",
  NETWORK_GATEWAY_MSG: "\n- O IP da rede não pode ser utilizado como IP do gateway",
  RESTART_SYSTEM_PROTOCOL: " Reiniciar sistema",
  UPDATING_MONITOR_FILES_PROTOCOL: "Atualizando arquivos no monitor. Por favor aguarde.",
  MONITOR_FILES_UPDATED_SUCCESSFULLY_PROTOCOL: "Arquivos atualizados, preparando para reiniciar o monitor.",
  RESTARTING_MONITOR_WAIT_PROTOCOL: "Reiniciando o monitor, aguarde alguns minutos.",
  UPDATE_ERROR_STRING_PROTOCOL: "Ocorreu o seguinte erro ao atualizar o monitor: ",
  TAG_WAS_CHANGED_SUCCESSFULLY_PROTOCOL: "A tag do monitor foi modificada com sucesso.",
  TAG_CHANGE_FAILURE_PROTOCOL: "Ocorreu um erro ao modificar a tag do monitor.",
  THE_FOLLOWING_FILES_COULD_NOT_BE_SENT: "Ocorreu um erro ao enviar os seguintes arquivos GSD: ",
  THE_FOLLOWING_FILES_COULD_NOT_BE_REMOVED: "Ocorreu um erro ao remover os seguintes arquivos GSD: ",
  MANAGE: "Gerenciar",
  TAG_CONFIG_PROTOCOL: "Tag da rede",
  ETHERNET_POPUP_2_PROTOCOL: "Utilizado para supervisão e acesso Web aos dados do monitor.",
  WLAN_POPUP_2_PROTOCOL: "Utilizado para supervisão e acesso Web aos dados do monitor.",
  TURN_NTP_SERVER_ON_QUESTION_PROTOCOL: "Tem certeza que deseja ligar o servidor NTP? Para isso o monitor precisará ser reiniciado.",
  MONITOR_RESTART_SUCCESS_PROTOCOL: "O monitor foi reiniciado com sucesso.",
  MONITOR_RESTART_FAILURE_PROTOCOL: "Ocorreu um erro ao reiniciar o monitor.",
  UPDATE_WLAN_CONFIG_ERROR_PROTOCOL: "Não foi possível conectar à rede WLAN. Caso o problema persista tente reiniciar o monitor ou o roteador WLAN.",
  ARE_YOU_SURE_ALTER_CONFIG_PROTOCOL: "Tem certeza que deseja alterar as configurações do TS Monitor DN?",
  SEND: "Enviar",
  GSD_FILES: "Arquivos GSD",
  IP_PLACEHODLER_PROTOCOL: "192.168.2.215",
  ALTER_MONITOR_WLAN_CONFIG_PROTOCOL: "Tem certeza que deseja alterar as configurações de WLAN do monitor?",
  WLAN_STATUS_POPUP_1_PROTOCOL: "Indica o estado do adaptador WLAN do monitor.",
  CONNECTION_STATUS_POPUP_1_PROTOCOL: "Indica se o monitor está conectado ou não à rede WLAN configurada.",
  WLAN_CONFIG_POPUP_2_PROTOCOL: "É altamente recomendado que as configurações de WLAN sejam alteradas apenas ao acessar o monitor por meio da rede cabeada.",
  WLAN_ADAPTER_NOT_FOUND_1_PROTOCOL: "O TS Monitor DeviceNet não conseguiu encontrar o adaptador WLAN:\n",
  WLAN_ADAPTER_NOT_FOUND_2_PROTOCOL: "  • Verifique se o adaptador está desconectado, ou com mal contato;\n",
  WLAN_ADAPTER_NOT_FOUND_3_PROTOCOL: "  • Caso o adaptador não esteja desconectado nem com mal contato, tente substituí-lo;\n",
  ALTER_MONITOR_HOSTNAME_CONFIRM_1: "Tem certeza que deseja alterar o hostname?",
  ALTER_MONITOR_HOSTNAME_CONFIRM_2: "Para isso é necessário reiniciar o monitor.",
  HOSTNAME_POPUP_1: "Um hostname deve possuir entre 2 e 64 caracteres para ser válido.",
  HOSTNAME_POPUP_2: "Além disso, ele pode conter apenas letras, números, pontos e hífens, e deve começar e terminar apenas com letras e números.",
  INVALID_HOSTNAME_1: "O hostname deve possuir entre 2 e 64 caracteres.",
  INVALID_HOSTNAME_2: "O hostname deve conter apenas letras, números, pontos e hífens, e deve começar e terminar apenas com letras e números.",
  DISP_DIAG: "Dispositivo",
  DIAGNOSTIC1: "Diagnóstico 1",
  DIAGNOSTIC2: "Diagnóstico 2",
  DIAGNOSTIC3: "Diagnóstico 3",
  DIAGNOSTIC4: "Diagnóstico 4",
  DIAGNOSTIC5: "Diagnóstico 5",
  DIAGNOSTIC6: "Diagnóstico 6",
  DIAGNOSTIC7: "Diagnóstico 7",
  DIAGNOSTIC8: "Diagnóstico 8",
  DIAGNOSTIC_LIST: "Lista de diagnósticos",
  DATA_FIELD_PLACEHODLER: "Data",
  BIT1: "Bit 1:",
  BIT2: "Bit 2:",
  BIT3: "Bit 3:",
  BIT4: "Bit 4:",
  BIT5: "Bit 5:",
  BIT6: "Bit 6:",
  BIT7: "Bit 7:",
  BIT8: "Bit 8:",
  DIAG_SUCcESS_MSG: "O diagnóstico foi alterado com sucesso.",
  REMOVE_DIAG_FAILURE: "Ocorreu um erro ao alterar o diagnóstico as tags",
  REMOVE_GSD_SUCCESS: "Os arquivos GSD foram removidos com sucesso",
  REMOVE_GSD_FILES: "Gerenciar arquivos GSD",
  SELECT_AT_LEAST_ONE_FILE_TO_DELETE: "Por favor selecione ao menos um arquivo para remover",
  REMOVING_GSD_FILES: "Removendo arquivos GSD",
  FILTER_GSD_FILES: "Filtrar arquivos GSD",
  DeviceNet: "DeviceNet",
  REPORT_EXPORT_NAME_PROTOCOL: "Relatório TS Monitor DeviceNet",
  HEADER_TEXT_PROTOCOL: "Relatório de dados - TS Monitor DeviceNet - Protocolo",
  MONITORING_INFO: "Informações do monitoramento",
  CONFORM_STRING: "Conforme",
  CONFORM_W_RESTRICTION_STRING: "Conforme com restrições",
  NON_CONFORM_STRING: "Não conforme",
  TAG_NAME_DN: "- Tag da rede: ",
  MONITOR_VERSION_DN: "- Versão do monitor: ",
  MONITOR_INIT_DN: "- Inicio do monitoramento: ",
  GENERATING_TIME_DN: "- Geração do relatório: ",
  DURATION_SINCE_MON_BEGIN: "- Duração do monitoramento até a geração do relatório: ",
  TS_MONITOR_VER_DP: "TS Monitor DeviceNet - Versão ",
  NETWORK_AVAILABILITY_DP: "Disponibilidade da rede: ",
  BAUD_RATE_PROTOCOL: "Baud rate: ",
  CYCLE_TIME_PROTOCOL: "Tempo de ciclo: ",
  OCUP_BANDA_DN: "Ocupação de Banda (%): ",
  DEVICE_DATA: "Dados dos dispositivos",
  MASTERS_DN: "Mestres: ",
  SLAVES_DN: "Devices: ",
  ONLINE_SLAVES_DP: "Devices online: ",
  MISSING_DN: "Ausentes: ",
  RETRIES_DN: "Retentativas: ",
  DIAGNOSTIC_DN: "Diagnósticos: ",
  FAULT_DN: "Falhas: ",
  ERROR_FRAME: "Error Frames: ",
  WATCHDOG_DP: "Watchdog: ",
  RETRIES_LIMIT_DP: "Limite de retentativa: ",
  HSA_DP: "HSA: ",
  MATRIX: "Matriz",
  GRAPHIC_TOPOLOGY: "Topologia gráfica",
  CONFIG_STRING: "Configurações",
  RESUME_DOTS: ".......................................................................................................................................",
  LIVE_LIST_DOTS_PROTOCOL: ".......................................................................................................................................",
  MON_LOG_DOTS: "...............................................................................................................................................",
  DISCLAIMER_DOTS_PROTOCOL: "...................................................................................................................................",
  M_MONITORING_RESUME_PAGE_TITLE: "1.1. - Resumo",
  M_MONITORING_LIVE_LIST_PAGE_TITLE: "1.2. Live List",
  M_MONITORING_LOG_PAGE_TITLE: "1.3. - Log",
  PROTOCOL_RESUME_PAGE_TITLE: "1. - Resumo",
  PROTOCOL_LIVE_LIST_PAGE_TITLE: "2. Live List",
  PROTOCOL_LOG_PAGE_TITLE: "3. - Log",
  ONLINE_STRING: "Online",
  MISSING_PLURAL_STRING: "Ausentes",
  MISSING_SINGULAR_STRING: "Ausente",
  CONFIG_ERROR_STRING: "Erro de configuração",
  PARAM_ERROR_STRING: "Erro de parametrização",
  GOOD_STRING_PROTOCOL: "OK",
  BAD_STRING_PROTOCOL: "Falha",
  FAULT_STRING: "Falha",
  DIAGNOSTIC_STRING: "Diagnóstico",
  CRITIC_SLAVE_STRING: "Device crítico",
  MASTER_FAULT_STRING: "Mestre",
  SLAVE_MASTER_FAULT_STRING: "Mestre em falha",
  MPI_STRING: "MPI",
  MPI_CSV_FAULT_STRING: "MPI em falha",
  MASTER_CLASS_2: "Mestre",
  MASTER_OPERATE: "Mestre - operate",
  MASTER_SYNC: "Mestre - sync",
  MASTER_UNSYNC: "Mestre - unsync",
  MASTER_FREEZE: "Mestre - freeze",
  MASTER_UNFREEZE: "Mestre - unfreeze",
  MASTER_CLEAR: "Mestre - clear",
  CLASS_2: "",
  MASTER_OPERATE_CAPITAL: "Mestre - Operate",
  MASTER_SYNC_CAPITAL: "Mestre - Sync",
  MASTER_UNSYNC_CAPITAL: "Mestre - Unsync",
  MASTER_FREEZE_CAPITAL: "Mestre - Freeze",
  MASTER_UNFREEZE_CAPITAL: "Mestre - Unfreeze",
  MASTER_CLEAR_CAPITAL: "Mestre - Clear",
  REMOVE_DEVICE_SUCCESS: "O dispositivo será removido em até 30 segundos.",
  REMOVE_DEVICE_FAILURE: "Ocorreu um erro ao remover o dispositivo: ",
  WITH_DIAGNOSTIC_STRING: "A rede possui devices em diagnóstico",
  WITH_FAILURE_STRING: "A rede possui devices em falha",
  WITH_CRITICAL_SLAVE_STRING: "A rede possui devices em estado crítico",
  WITH_MASTER_FAULT_STRING: "A rede possui mestres em falha",
  LIVE_LIST_INPUT_TEXT_PLACEHOLDER_PROTOCOL: "Filtrar por endereço ou status",
  LOG_INPUT_TEXT_PLACEHOLDER_PROTOCOL: "Filtrar por endereço e tag",
  SLAVE_DIAGNOSTIC: "Diagnóstico do device:",
  NETWORK_EVENT: "Evento da rede",
  MASTER_HASHTAG: "Mestre #",
  CONFIG_ERROR_1: "Erro de ",
  CONFIG_ERROR_2: "configuração",
  PARAM_ERROR_1: "Erro de ",
  PARAM_ERROR_2: "parametrização",
  LAST_EVENT: "Último evento: ",
  DIAGNOSTICS_STRING: "Diagnósticos",
  ERROR_FRAMES_STRING: "Error Frames (Primeira detecção)",
  ERROR_FRAMES_UPDATE_STRING: "Error Frames",
  RETRIES_STRING: "Retentativas",
  NUM_OF_DEVICES_STRING: "Número de Devices",
  FAULTS_STRING: "Falhas",
  WATCHDOG_STRING: "Watchdog",
  BILLION_OF: "Bilhão de",
  BILLIONS_OF: "Bilhões de",
  MILLION_OF: "Milhão de",
  MILLIONS_OF: "Milhões de",
  THOUSAND: "Mil",
  LAST_EVENT_TOO_BIG_STRING: "Descrição muito longa, favor consultar o log.",
  CRITICAL_SLAVE_EXPLANATION: "O TS monitor possui uma função automática de selecionar os devices que possuam um número excessivo de eventos e informa ao usuário que este dispositivo é crítico à rede DeviceNet.",
  DIAGNOSTICS_QUESTION_INFO: " Indica o número de diagnósticos detectados na rede DeviceNet. Diagnósticos indicam condições anormais de estado do dispositivo, como curto-circuito, problema de alimentação, falta de módulo, etc.",
  RETRIES_QUESTION_INFO: "Indica o número de vezes que o mestre precisou reenviar ums mensagem para determinado equipamento após não receber resposta. Indica, usualmente, problemas no meio físico.",
  FAULTS_QUESTION_INFO: "Indica o número vezes que determinado equipamento DeviceNet parou de responder mensagens do mestre.",
  WATCHDOG_QUESTION_INFO_1: "O watchdog é o tempo que o device aguarda após perder a comunicação com o mestre até modificar suas saídas para a condição de segurança.",
  WATCHDOG_QUESTION_INFO_2: "Este parâmetro é enviado pelo mestre a todos os devices da rede, individualmente, em seu respectivo telegrama de parametrização.",
  WATCHDOG_QUESTION_INFO_3: "Se o tempo de ciclo estiver próximo ao watchdog a rede fica mais vulnerável.",
  WATCHDOG_QUESTION_INFO: "Indica se o watchdog para o dispositivo está ativo, inativo, ou se ainda não foi parametrizado.",
  GRAPHIC_TOPOLOGY_INPUT_PLACEHOLDER: "Pesquisar device por endereço ou tag",
  EDIT_TOPOLOGY_POS_STRING: "Editar",
  SAVE_TOPOLOGY_POS_STRING: "Salvar",
  DELETE_TOPOLOGY_POS_STRING: "Remover",
  EXPORT_SVG: "SVG",
  EXPORT_TOPOLOGY: "Topologia",
  IMPORT_TOPOLOGY: "Importar Topologia",
  POSITION: "Posição",
  SAVE_TOPOLOGY_POS_SUCCESS_STRING: "O posicionamento da topologia foi salvo com sucesso!",
  SAVE_TOPOLOGY_POS_FAILURE_STRING: "Ocorreu o seguinte erro ao salvar o posicionamento da topologia: ",
  DROP_TOPOLOGY_POS_SUCCESS_STRING: "O posicionamento da topologia foi removido com sucesso!",
  DROP_TOPOLOGY_POS_FAILURE_STRING: "Ocorreu o seguinte erro ao remover o posicionamento da topologia: ",
  ASK_REMOVE_POSITIONING: "Tem certeza que deseja remover o posicionamento salvo?",
  REMOVE_POSITIONING: "Remover posicionamento",
  ALERT_NOT_POSSIBLE_TO_EDIT: "Não é possível editar dados do mestre",
  ALERT_NOT_POSSIBLE_TO_EDIT_SCOPE: "Não é possível editar os dados do TS Monitor",
  ALERT_NOT_POSSIBLE_TO_DELETE: "Não é possível remover um device da live list",
  ALERT_CHOOSE_DEVICE_TYPE: "Por favor escolha um tipo de dispositivo",
  ALERT_CHOOSE_CONNECTION_TYPE: "Por favor selecione um tipo de conexão",
  ADD_DEVICE: "Adicionar dispositivo",
  TAG_PLACEHOLDER: "TAG (opcional)",
  DEVICE_DEFAULT_DROPDOWN_PLACEHOLDER: "Escolha um tipo de dispositivo",
  ADD_CONNECTION: "Adicionar conexão",
  CONNECTION_DEFAULT_DROPDOWN_PLACEHOLDER: "Escolha um tipo de conexão",
  EDIT_DEVICE: "Editar dispositivo",
  CANCEL: "Cancelar",
  ADD: "Adicionar",
  MASTER_NAME: "Mestre",
  SLAVE_NAME: "Device",
  SLAVE_PA_NAME: "Device",
  REPEATER_NAME: "Repetidor",
  HUB_NAME: "Hub",
  JB_NAME: "Junction Box",
  COUPLER_PROXY_NAME: "Coupler/Proxy",
  FIBER_LINK_NAME: "Link de fibra",
  ACTIVE_TERMINATION_NAME: "Terminador ativo",
  UNKNOWN_NAME: "Desconhecido",
  TS_MONITOR_NAME: "TS Monitor",
  MPI_NAME: "MPI",
  LOCALE_EDIT: "Editar",
  LOCALE_DEL: "Remover selecionado",
  LOCALE_BACK: "Voltar",
  LOCALE_ADD_NODE: "Adicionar dispositivo",
  LOCALE_ADD_EDGE: "Adicionar conexão",
  LOCALE_EDIT_NODE: "Editar dispositivo",
  LOCALE_EDIT_EDGE: "Editar conexão",
  LOCALE_ADD_DESCRIPTION: "Clique em um espaço em branco para adicionar um novo dispositivo",
  LOCALE_EDGE_DESCRIPTION: "Clique em um dispositivo e arraste a conexão até outro dispositivo para conectá-los",
  LOCALE_EDIT_EDGE_DESCRIPTION: "Clique nos pontos de controle e os arraste para um dispositivo para conectá-los",
  LOCALE_CREATE_EDGE_ERROR: "Não é possível criar conexão para um cluster",
  LOCALE_DELETE_CLUSTER_ERROR: "Clusters não podem ser removidos",
  LOCALE_EDIT_CLUSTER_ERROR: "Clusters não podem ser editados",
  FORM_NO_DEVICE_FOUND_PREFIX: "O dispositivo de endereço ",
  FORM_NO_DEVICE_FOUND_SUFFIX: " não foi encontrado",
  INSERT_VALID_ADDRESS_OR_TAG: "Favor digitar um endereço ou tag válidos",
  INSERT_VALID_ADDRESS0_TAG_OR_MODEL: "Favor digitar um endereço ou tag válidos",
  POSITIONING_CONFLICT_1: "Há um conflito nas informações dos dispositivos de endereços:",
  POSITIONING_CONFLICT_2: "\nPor conta disso, suas posições e conexões voltarão ao estado padrão.",
  POSITIONING_ANG_CONNECTIONS_RESET_SUCCESS: "Posicionamentos e conexões retornados ao estado padrão com sucesso",
  POSITIONING_ANG_CONNECTIONS_RESET_FAILURE: "Ocorreu o seguinte erro ao retornar os posicionamentos e conexões ao estado padrão: ",
  TOPOLOGY_IMPORT_SUCCESS: "A topologia foi importada com sucesso!",
  ERROR_IMPORTING_GRAPHIC_TOPOLOGY: "Ocorreu um erro ao importar a topologia gráfica: ",
  PLEASE_SELECT_TOPOLOGY_FILE: "Por favor selecione um arquivo de topologia.",
  COLORS_LABELS: "Legenda de cores",
  LABEL_SLAVE_OK_MASTER_OP: ": Device ok, e mestre em operate;",
  LABEL_MASTER_STOP_CLEAR: ": Mestre em STOP / CLEAR;",
  LABEL_SLAVE_DIAG: ": Device em diagnóstico;",
  LABEL_SLAVE_N_MASTER_FAULT: ": Device em falha, e mestre em falha;",
  LABEL_SLAVE_CONFIG_ERROR: ": Device com erro de configuração;",
  LABEL_SLAVE_PARAM_ERROR: ": Device com erro de parametrização;",
  LABEL_SLAVE_ONLINE: ": Device online;",
  LABEL_SLAVE_MISSING: ": Device ausente;",
  LABEL_SLAVE_MASTER_FAULT: ": Device com mestre em falha;",
  LABEL_SLAVE_BLACKLIST: ": Device na blacklist;",
  LABEL_CRITICAL_SLAVE: ": Device critico;",
  LABEL_MPI: ": MPI;",
  LABEL_NO_STATUS: ": Dispositivo sem status.",
  DEVICE_TAG_NOT_FOUND: "Não foi encontrado nenhum dispositivo com a TAG: ",
  INSERT_VALID_ADDRESS_1_127: "Digite um endereço de device válido, entre 1 e 127.",
  DEVICE_WITH_ADDRESS: "O dispositivo de endereço ",
  WAS_SUCCESSFULLY_ADDED: " foi adicionado com sucesso.",
  WAS_SUCCESSFULLY_REMOVED: " foi removido com sucesso.",
  IS_ALREADY_IN_NETWORK: " já está na rede.",
  REMOVE_DEVICE_ERROR: "Ocorreu o seguinte erro ao tentar remover o dispositivo: ",
  TS_SCOPE_NOT_FOUND: "Não foi possível encontrar o TS Monitor de IP:",
  INVALID_INSERTED_IP: "O IP inserido é inválido",
  TS_SCOPE_FETCH_SUCCESS: "Fetch do TS Monitor deu certo",
  CONFIG_RETRIES_LIST_HEADER: "Retentativas",
  CONFIG_RETRIES_LIST_CONTENT: "Quando ativada esta opção, o TS Expert indicará todas as retentativas (retry), por dispositivo",
  CONFIG_DIAGNOSTIC_LIST_HEADER: "Diagnósticos",
  CONFIG_DIAGNOSTIC_LIST_CONTENT: "Quando ativada esta opção, o TS Expert indicará todos os diagnósticos, por dispositivo.",
  CONFIG_FAULT_LIST_HEADER: "Falhas",
  CONFIG_FAULT_LIST_CONTENT: "Quando ativada esta opção, o TS Expert indicará todas as falhas, por dispositivo.",
  CONFIG_FAULT_SEQUENCE_LIST_HEADER: "Sequência de falhas",
  CONFIG_FAULT_SEQUENCE_LIST_CONTENT: "Quando ativada esta opção, o TS Expert registrará todas as falhas que ocorreram em sequência em caso de falhas de diversos dispositivos.",
  CONFIG_CONFIG_ERROR_LIST_HEADER: "Erro de configuração",
  CONFIG_CONFIG_ERROR_LIST_CONTENT: "Quando ativada esta opção, o TS Expert indicará todos os dispositivos que apresentam erro de configuração.",
  CONFIG_ERROR_FRAME_LIST_HEADER: "Error Frame",
  ERROR_FRAME_LIST_CONTENT: "Quando ativada esta opção, o TS Expert indicará a ocorrencia de error frames.",
  CONFIG_PARAM_ERROR_LIST_HEADER: "Erro de parametrização",
  CONFIG_PARAM_ERROR_LIST_CONTENT: "Quando ativada esta opção, o TS Expert indicará todos os dispositivos que apresentam erro de parametrização.",
  CONFIG_MISSING_LIST_HEADER: "Device ausente",
  CONFIG_MISSING_LIST_CONTENT: "Quando ativada esta opção, o TS Expert indicará todos os devices ausentes.",
  CONFIG_ONLINE_LIST_HEADER: "Device online",
  CONFIG_ONLINE_LIST_CONTENT: "Quando ativada esta opção, o TS Expert indicará todos os devices online.",
  CONFIG_CRITICAL_SLAVE_LIST_HEADER: "Device crítico",
  CONFIG_CRITICAL_SLAVE_LIST_CONTENT: "Quando ativada esta opção, o TS Expert registrará todos os devices críticos.",
  CONFIG_MASTER_FAULT_LIST_HEADER: "Mestre em falha",
  CONFIG_MASTER_FAULT_LIST_CONTENT: "Quando ativada esta opção, o TS Expert indicará quando o TS Monitor não estiver recebendo frames DeviceNet.",
  TS_EXPERT_REPORT_EXPORT_NAME_PROTOCOL: "Lista de ações - TS Expert - DeviceNet",
  TS_EXPERT_POPUP_2_PROTOCOL: "Esta ferramenta é um sistema especialista desenvolvido para otimizar e acelerar a análise das principais divergências detectadas pelo TS Monitor em redes DeviceNet.",
  RETRIES_LIST_HEADER: "Existem dispositivos na rede que possuem retentativas.",
  DEVICE_WITH_RETRIES: "Dispositivo com retentativas (Primeira Detecção)",
  DEVICE_UPDATE_WITH_RETRIES: "Dispositivo com retentativas",
  RETRIES_INITIAL_ERROR_MSG: "Não foi possível conferir os eventos dos seguintes dispositivos, pois eles ainda possuem retentativas:\n",
  S_RETRIES_INITIAL_ERROR_MSG: "Não foi possível conferir o evento do dispositivo, pois eles ainda possui retentativas\n",
  RETRIES_SUGGESTION_1: "Quando um dispositivo possuir retentativas sugere-se:",
  RETRIES_SUGGESTION_2: "As retentativas indicam o número de vezes que o mestre precisou reenviar uma mensagem para determinado equipamento após não receber resposta, seja porque o device não respondeu ou porque a resposta estava corrompida (frame ilegal ou incompleto), por efeito de ruido, baixo isolamento em device ou na infra-estrutura do barramento.",
  RETRIES_SUGGESTION_3: "Verificar e corrigir a montagem das conexões;",
  RETRIES_SUGGESTION_4: "Verificar danos ao cabo DeviceNet, como:",
  RETRIES_SUGGESTION_5: "Dobras menores que 10 vezes o raio do condutor;",
  RETRIES_SUGGESTION_6: "Cortes no cabo;",
  RETRIES_SUGGESTION_7: "Torções no cabo;",
  RETRIES_SUGGESTION_8: "Amassados no cabo.",
  RETRIES_SUGGESTION_9: "Estas não conformidades exigem a troca do trecho de cabo (não é possível solucionar a não conformidade desdobrando ou desamassando o cabo);",
  RETRIES_SUGGESTION_10: "Verifique se há cabos de potência próximos a cabos DeviceNet. Cabos de dados devem estar separados o mais distante possível ou em eletrocalhas/eletrodutos fechados e aterrados, seguindo o mínimo indicado pelas diretrizes de acordo com a classificação do condutor elétrico, norma EN50174;",
  RETRIES_SUGGESTION_11: "Medir corrente de fuga no cabo com um alicate adequado, se medida for maior que 100mA é necessário conferir a equipotencialização e o sistema de aterramento;",
  RETRIES_SUGGESTION_12: "Verificação da qualidade do sinal com o meio físico DeivceNet, que lhe dará as dicas segundo as medições realizadas;",
  RETRIES_SUGGESTION_13: "Caso nenhum dos itens acima resolva, e um determinado equipamento esteja apresentando retentativas isoladamente (apenas um determinado device apresenta retentativas), sugere-se substituir a interface de rede do device.",
  RETRIES_SUGGESTION_14: "O único item que pode ter melhor resultado com a planta rodando é o item “e”, porém o uso de analisador deve ser realizado com cautela pois caso a condição sinal esteja muito comprometido pode derrubar a rede.",
  DIAGNOSTIC_LIST_HEADER: "Existem dispositivos na rede que possuem diagnósticos.",
  DEVICE_WITH_DIAGNOSTIC: "Dispositivo com diagnósticos (Primeira detecção)",
  DEVICE_UPDATE_WITH_DIAGNOSTIC: "Dispositivo com diagnósticos",
  DIAGNOSTIC_INITIAL_ERROR_MSG: "Não foi possível conferir os eventos dos seguintes dispositivos, pois eles ainda possuem diagnósticos:\n",
  S_DIAGNOSTIC_INITIAL_ERROR_MSG: "Não foi possível conferir o evento do dispositivo, pois ele ainda possui diagnósticos\n",
  DIAGNOSTIC_SUGGESTION_1: "Quando um dispositivo possuir diagnósticos sugere-se:",
  DIAGNOSTIC_SUGGESTION_2: "O estado “Diagnóstico” é uma informação enviada pelo device ao mestre, geralmente não é um problema de rede e sim um aviso do device que ele está precisando de manutenção ou substituição.",
  DIAGNOSTIC_SUGGESTION_3: "Caso um device apresente diagnóstico verifique a informação enviada e tente solucionar o problema, caso tenha dificuldade em entender o diagnóstico entre em contato com o fabricante do device para sanar suas dúvidas antes de uma intervenção;",
  DIAGNOSTIC_SUGGESTION_4: "O número crescente de diagnóstico sem dados de manutenção pode estar ligado diretamente as falhas do dispositivo, pois quando o equipamento volta a comunicar existe um diagnóstico de conferência, que verifica se o device está pronto para troca de dados. Verifique se o número de diagnóstico está próximo ao de falhas, neste caso siga o passo-a-passo de testes para falhas.",
  FAULT_LIST_HEADER: "Existem dispositivos na rede que possuem falhas.",
  DEVICE_WITH_FAULT: "Dispositivo com falhas (Primeira detecção)",
  DEVICE_UPDATE_WITH_FAULT: "Dispositivo com falhas",
  FAULT_INITIAL_ERROR_MSG: "Não foi possível conferir os eventos dos seguintes dispositivos, pois eles ainda possuem falhas:\n",
  S_FAULT_INITIAL_ERROR_MSG: "Não foi possível conferir o evento do dispositivo, pois ele ainda possui falhas\n",
  ERROR_FRAME_MSG: "Não foi possível conferir o evento, pois a rede ainda possui error frames\n",
  FAULT_SUGGESTION_1: "Quando um dispositivo possuir falhas sugere-se:",
  FAULT_SUGGESTION_2: "O estado “Falha” indica que o device parou de comunicar, ou seja deixou de trocar dados com o mestre (caiu da rede). Neste caso não há como determinar o motivo da falha, que pode ser, por exemplo, o rompimento de um cabo ou falta de alimentação elétrica:",
  FAULT_SUGGESTION_3: "Verificar a alimentação do device;",
  FAULT_SUGGESTION_4: "Verificar se está conectado à rede;",
  FAULT_SUGGESTION_5: "Verificar a integridade e correta montagem do conector;",
  FAULT_SUGGESTION_6: "Verificar a integridade do cabo;",
  ERROR_FRAME_LIST_HEADER: "Error Frame.",
  DEVICE_WITH_ERROR_FRAME: "Error Frame (Primeira detecção)",
  DEVICE_WITH_UPDATE_ERROR_FRAME: "Error Frame",
  ERROR_FRAME_SUGGESTION_1: "Quando for detectado um error frame na rede sugere-se:",
  ERROR_FRAME_SUGGESTION_2: "O erro de frame indica que ocorreu o envio de uma mensagem incorreta, seja pela falta de stuff bit na mensagem, CRC incorreto, resposta estava corrompida (frame ilegal ou incompleto).",
  ERROR_FRAME_SUGGESTION_3: "Verificar e corrigir a montagem das conexões;",
  ERROR_FRAME_SUGGESTION_4: "Verificar danos ao cabo DeviceNet, como:",
  ERROR_FRAME_SUGGESTION_5: "Dobras menores que 10 vezes o raio do condutor;",
  ERROR_FRAME_SUGGESTION_6: "Cortes no cabo;",
  ERROR_FRAME_SUGGESTION_7: "Torções no cabo;",
  ERROR_FRAME_SUGGESTION_8: "Amassados no cabo.",
  ERROR_FRAME_SUGGESTION_9: "Estas não conformidades exigem a troca do trecho de cabo (não é possível solucionar a não conformidade desdobrando ou desamassando o cabo);",
  ERROR_FRAME_SUGGESTION_10: "Verifique se há cabos de potência próximos a cabos DeviceNet. Cabos de dados devem estar separados o mais distante possível ou em eletrocalhas/eletrodutos fechados e aterrados, seguindo o mínimo indicado pelas diretrizes de acordo com a classificação do condutor elétrico, norma EN50174;",
  ERROR_FRAME_SUGGESTION_11: "Medir corrente de fuga no cabo com um alicate adequado, se medida for maior que 100mA é necessário conferir a equipotencialização e o sistema de aterramento;",
  ERROR_FRAME_SUGGESTION_12: "Verificação da qualidade do sinal com o meio físico DeviceNet, que lhe dará as dicas segundo as medições realizadas;",
  ERROR_FRAME_SUGGESTION_13: "Caso nenhum dos itens acima resolva, e um determinado equipamento esteja apresentando retentativas isoladamente (apenas um determinado device apresenta retentativas), sugere-se substituir a interface de rede do device.",
  ERROR_FRAME_SUGGESTION_14: "O único item que pode ter melhor resultado com a planta rodando é o item “e”, porém o uso de analisador deve ser realizado com cautela pois caso a condição sinal esteja muito comprometido pode derrubar a rede.",
  MISSING_LIST_HEADER: "Existem dispositivos ausentes na rede.",
  DEVICE_MISSING: "Dispositivo ausente",
  DEVICE_MISSING_UPDATE: "Dispositivo ausente",
  MISSING_INITIAL_ERROR_MSG: "Não foi possível conferir os eventos dos seguintes dispositivos, pois eles ainda estão ausentes:\n",
  S_MISSING_INITIAL_ERROR_MSG: "Não foi possível conferir o evento do dispositivo, pois ele ainda está ausentes\n",
  MISSING_SUGGESTION_1: "Quando um dispositivo estiver ausente sugere-se:",
  MISSING_SUGGESTION_2: "Ocorre quando o mestre ou SDCD está buscando um device na rede mas não recebe resposta. Este device foi configurado no projeto, mas não está respondendo na rede ou não esta instalado. Sugestão:",
  MISSING_SUGGESTION_3: "Verifique se o device declarado no software do mestre ou SDCD está conectado à rede e alimentado.",
  MISSING_SUGGESTION_4: "Não é indicado deixar o mestre ou SDCD buscando devices que não serão instalados.",
  DEVICE_WITH_RETRIES_DOTS: "........................................................................................................",
  DEVICE_WITH_DIAGNOSTIC_DOTS: "......................................................................................................",
  DEVICE_WITH_FAULT_DOTS: ".................................................................................................................",
  DEVICE_WITH_CONFIG_ERROR_DOTS: ".........................................................................................",
  DEVICE_WITH_ERROR_FRAME_DOTS: "....................................................................................................................................",
  DEVICE_WITH_PARAM_ERROR_DOTS: ".....................................................................................",
  DEVICE_MISSING_DOTS: ".......................................................................................................................",
  DEVICE_ONLINE_DOTS: "..........................................................................................................................",
  DEVICE_IS_CRITICAL_SLAVE_DOTS: "..................................................................................................",
  DEVICE_IS_MASTER_FAULT_DOTS: "...............................................................................................",
  DISCLAIMER_EXPERT_DOTS_1: "...................................................................................................................................",
  DISCLAIMER_EXPERT_DOTS_2_PROTOCOL: "......................................................................................................................................",
  ALL_EVENTS_CHECKED_SUCCESS: "Todos os eventos foram conferidos com sucesso.",
  SIGNAL_QUALITY: "Qualidade do sinal",
  SIGNAL_QUALITY_DESCRIPTION: "Na coluna “Sinal” sempre é considerado o pior caso, para Amplitude média e mínima.",
  SIGNAL_QUALITY_GOOD_DESCRIPTION: "• Amplitude Média maior ou igual a 2Vpp.",
  ATTENTION_PREVENTIVE_ACTION: "Atenção - Ação preventiva",
  ATTENTION_PREVENTIVE_ACTION_MINIMUM: "• Amplitude média maior ou igual a 1,5Vpp.",
  ATTENTION_PREVENTIVE_ACTION_MAXIMUM: "• Amplitude média menor que 2Vpp.",
  BAD_CORRECTIVE_ACTION: "Ruim - Ação corretiva",
  BAD_CORRECTIVE_ACTION_DESCRIPTION: "• Amplitude média menor que 1,5Vpp.",
  DIAGNOSTIC_BYTE: "BYTE DE DIAGNÓSTICO",
  ENABLE_DIAGNOSTIC: "Ativar Diagnóstico",
  ENABLE_DIAGNOSTIC_BIT: "Ativar Diagnóstico Bit ",
  INTERFACE_CONFIGURATION: "Configurações de Interface",
  CONFIGURE: "Configurar",
  NEW_PASSWORD: "Nova senha",
  REPEAT_PASSWORD: "Repetir senha",
  CLIENT_LOGO: "Logo do cliente",
  EXECUTING_COMPANY_LOGO: "Logo da empresa executora",
  TS_MONITOR_LOGO_ALT: "TS Monitor Logo",
  HORARY_DETECTION: "Horário de Detecção",
  ERROR_FRAMES: "Error Frames",
  USERNAME: "Usuário",
  EMAIL: "E-mail",
  HOSTNAME: "Hostname",
  TIMEZONE: "Timezone",
  DHCP: "DHCP",
  FIXED_IP: "IP Fixo",
  TEST_NETWORK: "Rede de teste",
  AVAILABLE_DEVICES_PLACEHOLDER: "Dispositivos",
  OBSERVATION_ABBREVIATION: "OBS",
  NOTE_ABBREVIATION: "Obs",
  FORM_PROJECT_NAME: "Nome do projeto",
  FORM_NETWORK_NAME: "Nome da rede",
  FORM_LOCATION: "Localização",
  FORM_COMPANY_NAME: "Nome da empresa",
  FORM_ACCOUNTABLE_NAME: "Nome do responsável",
  FORM_ADDRESS: "Endereço",
  FORM_CITY: "Cidade",
  FORM_PHONE: "Telefone",
  DIAGNOSTIC: "Diagnóstico",
  ACTIONS_LIST: "Lista de ações",
  RELATIVE_TIME_YEAR: "{value} ano",
  RELATIVE_TIME_YEARS: "{value} anos",
  RELATIVE_TIME_MONTH: "{value} mês",
  RELATIVE_TIME_MONTHS: "{value} meses",
  RELATIVE_TIME_DAY: "{value} dia",
  RELATIVE_TIME_DAYS: "{value} dias",
  RELATIVE_TIME_HOUR: "{value} hora",
  RELATIVE_TIME_HOURS: "{value} horas",
  RELATIVE_TIME_MINUTE: "{value} minuto",
  RELATIVE_TIME_MINUTES: "{value} minutos",
  CHART_TIME_VALUE: "Tempo: ",
  CHART_ADDRESS: "Endereço: ",
  CHART_LOCALE: "pt-br",
  CHART_MONTHS: "Janeiro|Fevereiro|Março|Abril|Maio|Junho|Julho|Agosto|Setembro|Outubro|Novembro|Dezembro",
  CHART_SHORT_MONTHS: "Jan|Fev|Mar|Abr|Mai|Jun|Jul|Ago|Set|Out|Nov|Dez",
  CHART_DAYS: "Domingo|Segunda|Terça|Quarta|Quinta|Sexta|Sábado",
  CHART_SHORT_DAYS: "Dom|Seg|Ter|Qua|Qui|Sex|Sab",
  CHART_EXPORT_SVG: "Baixar SVG",
  CHART_EXPORT_PNG: "Baixar PNG",
  CHART_EXPORT_CSV: "Baixar CSV",
  CHART_MENU: "Baixar",
  CHART_SELECTION: "Selecionar",
  CHART_SELECTION_ZOOM: "Selecionar zoom",
  CHART_ZOOM_IN: "Aumentar",
  CHART_ZOOM_OUT: "Diminuir",
  CHART_PAN: "Navegação",
  SAVE_REPORT: "Salvar relatório",
  FINALIZING: "Finalizando...",
  ACTION_LIST_TITLE: "Lista de ações - TS Monitor DN",
  SAVE_ACTION_LIST: "Salvar lista de ações",
  CHART_RESET_ZOOM: "Reiniciar zoom",
  GOOD_PREVENTIVE_ACTION_DESCRIPTION: "• Amplitude média maior ou igual a 2Vpp.",
  ATTENTION_PREVENTIVE_ACTION_DESCRIPTION_1: "• Amplitude média maior ou igual a 1,5Vpp.",
  ATTENTION_PREVENTIVE_ACTION_DESCRIPTION_2: "• Amplitude média menor que 2Vpp."
});
